import React from 'react';
import PropTypes from 'prop-types';
import {connect} from 'react-redux';
import {FormattedHTMLMessage, FormattedMessage} from 'react-intl';
import {cloneDeep, debounce, filter, get} from 'lodash';
import {toast} from 'react-toastify';

import '../../../../../styles/react-autosuggest.scss';

import filtersUtil from '../../../../utils/filters';
import {copyTextToClipboard, implode} from 'src/js/utils/utils';
import constants from '../../../../constants';
import {history} from 'src/js/store/configureStore';

import {
  declareCampaignWinners,
  deleteActivity,
  fetchActivities,
  fetchActivity,
  fetchActivityAnswers,
  fetchActivityRatings,
  fetchCacheActivities,
  fetchOpenActivities,
  hideActivityAnswersModal,
  hideActivityCommentModal,
  hideActivityModal,
  hideActivityRatingsModal,
  hideDisplayCriteriaModal,
  resetActivitiesData,
  resetActivitiesError,
  showActivityAnswersModal,
  showActivityLinkCopiedSnackbar,
  showDisplayCriteriaModal,
  toggleActivityState,
  updateActivityData,
} from 'src/js/actions/activitiesActions';

import {fetchLocalities, resetLocalitiesData,} from 'src/js/actions/locationAction';

import {cacheListData, fetchHelp, resetCacheListData} from 'src/js/actions/appActions';
import Space from "../../../commons/Space";
import Typography from "@material-ui/core/Typography";
import {
  ColorActive,
  ColorBackground,
  ColorCard,
  ColorCardXS,
  ColorClear,
  ColorGreen,
  ColorInactive,
  ColorNegative,
  ColorOrange,
  ColorSecondary,
  ColorSubTitle,
  ColorTableBorder,
  ColorTheme,
  ColorTitle,
  ColorTitleLite,
  ColorWhite
} from "src/styles/Colors";
import DateTimeHelper from "../../../../utils/DateTimeHelper";
import {Button, Divider, Fab, GridList, IconButton, MenuItem, Paper, Tooltip} from "@material-ui/core";
import {
  baseStyles,
  BORDER_RADIUS,
  BOTTOM_BAR_HEIGHT,
  BOTTOM_BAR_HEIGHT_XS,
  CARD_SPACING,
  changeNavColor,
  CONTENT_MAX_WIDTH,
  DRAWER_WIDTH,
  FIELD_SPACE,
  FONT_WEIGHT_BOLD,
  FONT_WEIGHT_MEDIUM,
  IS_BOTTOM_TAB_PRESENT,
  TOOLBAR_HEIGHT,
  TOOLBAR_HEIGHT_XS,
  withMediaQueries,
  withMultipleStyles
} from "src/styles/Styles";
import DialogTitle from "@material-ui/core/DialogTitle";
import DialogContent from "@material-ui/core/DialogContent";
import DialogActions from "@material-ui/core/DialogActions";
import Dialog from "@material-ui/core/Dialog";
import Snackbar from '@material-ui/core/Snackbar';
import MuiAlert from '@material-ui/lab/Alert';
import AddIcon from "@material-ui/icons/Add";
import HeaderTitleView from "../../../commons/HeaderTitleView";
import ValueHelper from "../../../../utils/ValueHelper";
import Menu from "@material-ui/core/Menu";
import DialogView from "../../../commons/DialogView";
import QRCode from "react-qr-code";
import TextView from "../../../commons/TextView";
import {
  isCurrentPlanEnded,
  isCurrentPlanNoPlan,
  isCurrentPlanPaid,
  isCurrentPlanViewEnded
} from "src/js/utils/ActivityHelper";
import {APP_URI} from "src/js/utils/services";
import PathHelper from "../../../../utils/PathHelper";
import InitiateVerifyAccount from "../../profile/InitiateVerifyAccount";
import CircularProgress from "@material-ui/core/CircularProgress";
import {VariableSizeList} from "react-window";
import InfiniteLoader from "react-window-infinite-loader";
import {
  getPathForActivity,
  getURLParameters,
  PathAboutUsPublic,
  PathHowItWorks,
  PathJoin,
  PathLanding
} from "../../../routes/NavHelper";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import Radio from "@material-ui/core/Radio";
import RadioGroup from "@material-ui/core/RadioGroup";
import AppUtils, {getCompletePath} from "../../../../utils/AppUtils";
import AppIcon, {IconAdd, IconMoreH} from "../../../commons/AppIcon";
import {ImageIcon, locString, SNACKBAR_AUTO_HIDE_DURATION} from "../../../commons/ViewHelper";
import {FETCH_CACHE_ACTIVITIES} from "src/js/constants/actionTypes";
import {getActivityInsightNavPath, getActivityReviewsNavPath} from "src/js/components/insight/ActivityInsight";
import ActivityAnswerDistributions from "src/js/components/activity/ActivityAnswerDistributions";
import auth from "src/js/utils/auth";
import VideoPlayer from "src/js/components/commons/VideoPlayer";
import {RadiusView} from "src/res/Radius";
import FocusHelperView from "src/js/components/commons/FocusHelperView";
import AppInstall from "src/js/components/commons/AppInstall";
import LanguageDialog from "src/js/components/commons/LanguageDialog";
import ActivityWinners from "src/js/components/activity/ActivityWinners";
import FieldSpace from "src/js/components/commons/FieldSpace";
import ApiHelper from "src/js/utils/ApiHelper";
import {doLoginGuest} from "src/js/actions/loginActions";

const ACTIONS_OFFER_VIEW_WIDTH = 148;
const ACTIONS_VIEW_WIDTH = 150;

const ALIGN_DIR = 'center';

const useStyles = (theme) => ({
  gridItemsWrapper: {
    display: 'flex',
    flex: 1,
    flexDirection: 'column',
    width: '100%',
    height: '100%',
    alignItems: 'center',
    overflow: 'hidden'
  },
  gridItemsWrapperXS: {
    display: 'flex',
    flex: 1,
    flexDirection: 'column',
    width: '100%',
    height: '100%',
    alignItems: 'center',
    overflow: 'hidden'
  },
  gridItems: {
    width: '100%',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    padding: 1,
  },
  cardItemWrapper: {
    display: 'flex',
    flexDirection: 'column',
    flex: 1,
    width: '100%',
    height: '100%',
    borderRadius: BORDER_RADIUS,
    backgroundColor: ColorCard,
    justifyContent: 'center',
    '&:hover': {
      backgroundColor: '#F5F7F9', // FAFCFE
      [theme.breakpoints.down('xs')]: {
        backgroundColor: '#F0F1F4',
      }
    },
    [theme.breakpoints.down('xs')]: {
      backgroundColor: ColorCardXS,
    }
  },
  cardItem: {
    display: 'flex',
    flexDirection: 'row',
    borderRadius: BORDER_RADIUS,
    position: 'relative',
  },
  cardItemActionWrapper: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    minWidth: ACTIONS_VIEW_WIDTH,
    width: ACTIONS_VIEW_WIDTH,
    borderRadius: BORDER_RADIUS,
    position: 'absolute',
    top: 0,
    bottom: 0,
    right: 0,
  },
  cardItemActionWrapperRTL: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    minWidth: ACTIONS_VIEW_WIDTH,
    width: ACTIONS_VIEW_WIDTH,
    borderRadius: BORDER_RADIUS,
    position: 'absolute',
    top: 0,
    bottom: 0,
    left: 0,
  },
  cardItemActionWrapperOffers: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    minWidth: ACTIONS_OFFER_VIEW_WIDTH,
    width: ACTIONS_OFFER_VIEW_WIDTH,
    borderRadius: BORDER_RADIUS,
    position: 'absolute',
    top: 0,
    bottom: 0,
    right: 0,
  },
  cardItemActionWrapperOffersRTL: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    minWidth: ACTIONS_OFFER_VIEW_WIDTH,
    width: ACTIONS_OFFER_VIEW_WIDTH,
    borderRadius: BORDER_RADIUS,
    position: 'absolute',
    top: 0,
    bottom: 0,
    left: 0,
  },
  cardItemActionWrapperV: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: ALIGN_DIR,
    minHeight: 48,
    height: 48,
    // backgroundColor: ColorThemeYellowField,
    // borderRadius: BORDER_RADIUS,
    // borderTopRightRadius: BORDER_RADIUS,
    // borderBottomRightRadius: BORDER_RADIUS,
    position: 'absolute',
    top: 0,
    bottom: 0,
    right: 0,
  },
  cardItemActionWrapperVRTL: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: ALIGN_DIR,
    minHeight: 48,
    height: 48,
    position: 'absolute',
    top: 0,
    bottom: 0,
    left: 0,
  },
  cardItemContent: {
    display: 'flex',
    flex: 1,
    width: '100%',
    flexDirection: 'row',
    padding: 8,
    paddingTop: 6,
    paddingBottom: 6,
    paddingRight: ACTIONS_VIEW_WIDTH + 8,
    minHeight: 50,
  },
  cardItemContentRTL: {
    display: 'flex',
    flex: 1,
    width: '100%',
    flexDirection: 'row',
    padding: 8,
    paddingTop: 6,
    paddingBottom: 6,
    paddingLeft: ACTIONS_VIEW_WIDTH + 8,
    minHeight: 50,
  },
  cardItemContentOffers: {
    display: 'flex',
    flex: 1,
    width: '100%',
    flexDirection: 'row',
    padding: 8,
    paddingTop: 6,
    paddingBottom: 6,
    paddingRight: ACTIONS_OFFER_VIEW_WIDTH + 8,
    minHeight: 50,
  },
  cardItemContentOffersRTL: {
    display: 'flex',
    flex: 1,
    width: '100%',
    flexDirection: 'row',
    padding: 8,
    paddingTop: 6,
    paddingBottom: 6,
    paddingLeft: ACTIONS_OFFER_VIEW_WIDTH + 8,
    minHeight: 50,
  },
  cardItemContentXS: {
    display: 'flex',
    flex: 1,
    width: '100%',
    flexDirection: 'column',
    padding: 8,
    paddingTop: 6,
    paddingBottom: 6,
    // paddingRight: 52,
    minHeight: 50,
  },
  cardItemContentPart1: {
    display: 'flex',
    width: '100%',
    flex: 1,
    flexDirection: 'row',
    minWidth: 150,
  },
  cardItemContentPart2: {
    display: 'flex',
    width: '100%',
    flex: 1,
    flexDirection: 'row',
    alignItems: 'center',
    minWidth: 250,
    // marginTop: 8,
  },
  cardImage: {
    borderRadius: 4,
    backgroundColor: ColorBackground,
  },
  buttonAdd: {
    marginTop: CARD_SPACING/2,
    marginBottom: CARD_SPACING,
    fontWeight: 'bold',
    position: 'relative',
    overflow: 'hidden',
    padding: 8,
    paddingLeft: 24,
    paddingRight: 24,
  },
  messageBox: {
    display: 'flex',
    flexDirection: 'column',
    width: '100%',
    minHeight: 400,
    alignItems: 'center',
    justifyContent: 'center',
    margin: 16,
  },
  menuItemBox: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    minHeight: 28
  },
  usageCardWrapper: {
    display: 'flex',
    width: '100%',
    flex: 1,
    flexDirection: 'row',
    maxWidth: 1300,
  },
  usageCard: {
    borderRadius: BORDER_RADIUS,
    overflow: 'hidden',
    backgroundColor: ColorWhite,
    padding: 8,
    margin: 4,
    minHeight: 126,
    border: `1px solid rgba(0,0,0,0.05)`
  },
  usageCardButtonBase: {
    position: 'relative',
    display: 'flex',
    flex: 1,
    width: '100%',
    flexDirection: 'row',
    borderRadius: BORDER_RADIUS,
    padding: 8,
    minHeight: 100,
    backgroundColor: ColorCard,
    [theme.breakpoints.down('xs')]: {
      backgroundColor: ColorCardXS,
      minHeight: 70,
    },
  },
  usageCardImage: {
    width: 44,
    height: 44,
    [theme.breakpoints.down('xs')]: {
      width: 36,
      height: 36,
    }
  },
  actionButtonIcon: {
    backgroundColor: '#E4EBF9',
    border: '1px solid #E4EBF9',
    '&:hover': {
      backgroundColor: AppUtils.darkerColor('#E4EBF9'),
    },
    borderRadius: 8,
    width: 38,
    height: 38,
  },
  moreButton: {
    backgroundColor: '#E4EBF9',
    '&:hover': {
      backgroundColor: "#d2ddf3",
    },
    borderRadius: 8,
    width: 36,
    height: 36,
  },
  moreButtonXS: {
    backgroundColor: '#E4EBF9',
    '&:hover': {
      backgroundColor: '#d2ddf3',
    },
    borderRadius: 8,
    width: 36,
    height: 36,
  },
  editButton: {
    height: 35,
    overflow: 'hidden',
    minWidth: 86,
    maxWidth: 90,
    borderRadius: 8,
    color: ColorTheme,
    backgroundColor: '#E4EEFF',
    border: '1px solid #0560FD3F',
    '&:hover': {
      backgroundColor: '#c3d3ee',
    },
  },
  promoteGreenButton: {
    height: 35,
    overflow: 'hidden',
    minWidth: 86,
    maxWidth: 90,
    borderRadius: 8,
    color: ColorActive,
    backgroundColor: '#DCF9F7',
    border: '1px solid rgba(29, 184, 175,0.25)',
    '&:hover': {
      backgroundColor: '#a0f3ec',
    },
  },
  promoteRedButton: {
    height: 35,
    overflow: 'hidden',
    minWidth: 86,
    maxWidth: 90,
    borderRadius: 8,
    color: ColorInactive,
    backgroundColor: '#FFE8E6',
    border: '1px solid rgba(234,67,53,0.25)',
    '&:hover': {
      backgroundColor: 'rgb(255,209,207)',
    },
  },
  textDialogDeclareOptionsHint: {
    marginLeft: 40,
    marginTop: -8,
  },
  planCard: {
    position: 'relative',
    display: 'flex',
    width: '100%',
    maxWidth: 340,
    minWidth: 250,
    flexDirection: 'row',
    borderRadius: BORDER_RADIUS,
    border: '1px solid '+ ColorTableBorder,
    [theme.breakpoints.down('xs')]: {
      maxWidth: 400,
      backgroundColor: ColorCardXS,
    },
  },
});

export const ACTIVITY_TYPES_MODEL = [
  {'id': constants.activity.types.SMART_AD, 'name': <FormattedMessage id='activity.type.smartAd'/>},
  {'id': constants.activity.types.OFFER, 'name': <FormattedMessage id='activity.type.offer'/>},
  {'id': constants.activity.types.VOUCHER, 'name': <FormattedMessage id='activity.type.voucher'/>},
  // {'id': 8, 'name': locString('discountOffer')},
  {'id': constants.activity.types.QUESTION, 'name': <FormattedMessage id='activity.type.question'/>},
  // {'id': constants.activity.types.BUYER_OPINION, 'name': <FormattedMessage id='activity.type.buyerOpinion'/>},
  {'id': constants.activity.types.VISITOR_OPINION, 'name': <FormattedMessage id='activity.type.visitorOpinion'/>},
  {'id': constants.activity.types.PREDICTION, 'name': <FormattedMessage id='activity.type.prediction'/>},
  {'id': constants.activity.types.GUESS, 'name': <FormattedMessage id='activity.type.guess'/>},
  {'id': constants.activity.types.IDENTIFY_LOCATION, 'name': <FormattedMessage id='activity.type.identifyLocation'/>},
  {'id': constants.activity.types.SLIDES, 'name': <FormattedMessage id='activity.type.slides'/>},
  {'id': constants.activity.types.SHOWCASE_MENU, 'name': <FormattedMessage id='activity.type.showcaseMenu'/>},
  {'id': constants.activity.types.QUESTIONNAIRE, 'name': <FormattedMessage id='activity.type.questionnaire'/>},
  {'id': constants.activity.types.SURVEY, 'name': <FormattedMessage id='activity.type.survey'/>},
  {'id': constants.activity.types.EVENT, 'name': <FormattedMessage id='activity.type.event'/>},
  {'id': constants.activity.types.CHALLENGE, 'name': <FormattedMessage id='activity.type.challenge'/>},
  {'id': constants.activity.types.SOCIAL_CONTENT, 'name': <FormattedMessage id='activity.type.contentWriting'/>},
  {'id': constants.activity.types.LIKE_USER, 'name': <FormattedMessage id='activity.type.shareNLike'/>},
  {'id': constants.activity.types.COLLECT_STARS, 'name': <FormattedMessage id='activity.type.collectStar'/>},
  {'id': constants.activity.types.JACKPOT, 'name': <FormattedMessage id='activity.type.gameSlot'/>},
  {'id': constants.activity.types.GAME_GREEDY_SPIN, 'name': <FormattedMessage id='activity.type.gameGreedySpin'/>},
  {'id': constants.activity.types.GAME_BETTING_PIC, 'name': <FormattedMessage id='activity.type.gameBettingPic'/>},
  {'id': constants.activity.types.GAME_ROULETTE, 'name': <FormattedMessage id='activity.type.gameRoulette'/>},
  {'id': constants.activity.types.GAME_SPIN_N_DISCOVER, 'name': <FormattedMessage id='activity.type.gameSpinNDiscover'/>},
  {'id': constants.activity.types.GAME_FLIP_CARD, 'name': <FormattedMessage id='activity.type.gameFlipCard'/>},
  {'id': constants.activity.types.GAME_FIND_HIDDEN, 'name': <FormattedMessage id='activity.type.gameFindHidden'/>},
  {'id': constants.activity.types.GAME_MATCH_PAIR, 'name': <FormattedMessage id='activity.type.gameMatchPair'/>},
  {'id': constants.activity.types.GAME_MATCH_THREE, 'name': <FormattedMessage id='activity.type.gameMatchThree'/>},
  {'id': constants.activity.types.GAME_PUZZLE, 'name': <FormattedMessage id='activity.type.gamePuzzle'/>},
  {'id': constants.activity.types.GAME_PUZZLE_SLIDE, 'name': <FormattedMessage id='activity.type.gamePuzzleSlide'/>},
  {'id': constants.activity.types.GAME_TIC_TAC_TOE, 'name': <FormattedMessage id='activity.type.gameTicTacToe'/>},
  {'id': constants.activity.types.GAME_POKER, 'name': <FormattedMessage id='activity.type.gamePoker'/>},
  {'id': constants.activity.types.GAME_WHAC_A_MOLE, 'name': <FormattedMessage id='activity.type.gameWhacAMole'/>},
  {'id': constants.activity.types.GAME_BRAND_RACE, 'name': <FormattedMessage id='activity.type.gameBrandRace'/>},
  {'id': constants.activity.types.EXTERNAL_GAMES, 'name': <FormattedMessage id='games'/>},
];

export const ACTIVITY_TYPES_CAMPAIGN_MODEL = [
  {'id': constants.activity.types.SMART_AD, 'name': <FormattedMessage id='activity.type.smartAd'/>},
  // {'id': 8, 'name': locString('discountOffer')},
  {'id': constants.activity.types.QUESTION, 'name': <FormattedMessage id='activity.type.question'/>},
  // {'id': constants.activity.types.BUYER_OPINION, 'name': <FormattedMessage id='activity.type.buyerOpinion'/>},
  {'id': constants.activity.types.VISITOR_OPINION, 'name': <FormattedMessage id='activity.type.visitorOpinion'/>},
  {'id': constants.activity.types.PREDICTION, 'name': <FormattedMessage id='activity.type.prediction'/>},
  {'id': constants.activity.types.GUESS, 'name': <FormattedMessage id='activity.type.guess'/>},
  {'id': constants.activity.types.IDENTIFY_LOCATION, 'name': <FormattedMessage id='activity.type.identifyLocation'/>},
  {'id': constants.activity.types.SLIDES, 'name': <FormattedMessage id='activity.type.slides'/>},
  {'id': constants.activity.types.SHOWCASE_MENU, 'name': <FormattedMessage id='activity.type.showcaseMenu'/>},
  {'id': constants.activity.types.QUESTIONNAIRE, 'name': <FormattedMessage id='activity.type.questionnaire'/>},
  {'id': constants.activity.types.SURVEY, 'name': <FormattedMessage id='activity.type.survey'/>},
  {'id': constants.activity.types.EVENT, 'name': <FormattedMessage id='activity.type.event'/>},
  {'id': constants.activity.types.CHALLENGE, 'name': <FormattedMessage id='activity.type.challenge'/>},
  {'id': constants.activity.types.SOCIAL_CONTENT, 'name': <FormattedMessage id='activity.type.contentWriting'/>},
  {'id': constants.activity.types.LIKE_USER, 'name': <FormattedMessage id='activity.type.shareNLike'/>},
  {'id': constants.activity.types.COLLECT_STARS, 'name': <FormattedMessage id='activity.type.collectStar'/>},
  {'id': constants.activity.types.JACKPOT, 'name': <FormattedMessage id='activity.type.gameSlot'/>},
  {'id': constants.activity.types.GAME_GREEDY_SPIN, 'name': <FormattedMessage id='activity.type.gameGreedySpin'/>},
  {'id': constants.activity.types.GAME_BETTING_PIC, 'name': <FormattedMessage id='activity.type.gameBettingPic'/>},
  {'id': constants.activity.types.GAME_ROULETTE, 'name': <FormattedMessage id='activity.type.gameRoulette'/>},
  {'id': constants.activity.types.GAME_SPIN_N_DISCOVER, 'name': <FormattedMessage id='activity.type.gameSpinNDiscover'/>},
  {'id': constants.activity.types.GAME_FLIP_CARD, 'name': <FormattedMessage id='activity.type.gameFlipCard'/>},
  {'id': constants.activity.types.GAME_FIND_HIDDEN, 'name': <FormattedMessage id='activity.type.gameFindHidden'/>},
  {'id': constants.activity.types.GAME_MATCH_PAIR, 'name': <FormattedMessage id='activity.type.gameMatchPair'/>},
  {'id': constants.activity.types.GAME_MATCH_THREE, 'name': <FormattedMessage id='activity.type.gameMatchThree'/>},
  {'id': constants.activity.types.GAME_PUZZLE, 'name': <FormattedMessage id='activity.type.gamePuzzle'/>},
  {'id': constants.activity.types.GAME_PUZZLE_SLIDE, 'name': <FormattedMessage id='activity.type.gamePuzzleSlide'/>},
  {'id': constants.activity.types.GAME_TIC_TAC_TOE, 'name': <FormattedMessage id='activity.type.gameTicTacToe'/>},
  {'id': constants.activity.types.GAME_POKER, 'name': <FormattedMessage id='activity.type.gamePoker'/>},
  {'id': constants.activity.types.GAME_WHAC_A_MOLE, 'name': <FormattedMessage id='activity.type.gameWhacAMole'/>},
  {'id': constants.activity.types.GAME_BRAND_RACE, 'name': <FormattedMessage id='activity.type.gameBrandRace'/>},
];

export const ACTIVITY_TYPES_CAMPAIGN_MODEL_ENTERTAINMENT = [
  {'id': constants.activity.types.GAME_ROULETTE, 'name': <FormattedMessage id='activity.type.gameRoulette'/>},
  {'id': constants.activity.types.JACKPOT, 'name': <FormattedMessage id='activity.type.gameSlot'/>},
  // {'id': constants.activity.types.GAME_GREEDY_SPIN, 'name': <FormattedMessage id='activity.type.gameGreedySpin'/>},
  {'id': constants.activity.types.GAME_SPIN_N_DISCOVER, 'name': <FormattedMessage id='activity.type.gameSpinNDiscover'/>},
  {'id': constants.activity.types.GAME_BRAND_RACE, 'name': <FormattedMessage id='activity.type.gameBrandRace'/>},
  {'id': constants.activity.types.GAME_POKER, 'name': <FormattedMessage id='activity.type.gamePoker'/>},
  {'id': constants.activity.types.GAME_TIC_TAC_TOE, 'name': <FormattedMessage id='activity.type.gameTicTacToe'/>},
  {'id': constants.activity.types.GAME_PUZZLE, 'name': <FormattedMessage id='activity.type.gamePuzzle'/>},
  {'id': constants.activity.types.GAME_PUZZLE_SLIDE, 'name': <FormattedMessage id='activity.type.gamePuzzleSlide'/>},
  {'id': constants.activity.types.GAME_FLIP_CARD, 'name': <FormattedMessage id='activity.type.gameFlipCard'/>},
  {'id': constants.activity.types.GAME_MATCH_PAIR, 'name': <FormattedMessage id='activity.type.gameMatchPair'/>},
  {'id': constants.activity.types.GAME_MATCH_THREE, 'name': <FormattedMessage id='activity.type.gameMatchThree'/>},
  {'id': constants.activity.types.GAME_BETTING_PIC, 'name': <FormattedMessage id='activity.type.gameBettingPic'/>},
  {'id': constants.activity.types.GAME_WHAC_A_MOLE, 'name': <FormattedMessage id='activity.type.gameWhacAMole'/>},
  // {'id': constants.activity.types.GAME_FIND_HIDDEN, 'name': <FormattedMessage id='activity.type.gameFindHidden'/>},
  // {'id': constants.activity.types.COLLECT_STARS, 'name': <FormattedMessage id='activity.type.collectStar'/>},
];

export const ACTIVITY_TYPES_CAMPAIGN_MODEL_INTERACTIVE = [
  {'id': constants.activity.types.GUESS, 'name': <FormattedMessage id='activity.type.guess'/>},
  {'id': constants.activity.types.IDENTIFY_LOCATION, 'name': <FormattedMessage id='activity.type.identifyLocation'/>},
  {'id': constants.activity.types.PREDICTION, 'name': <FormattedMessage id='activity.type.prediction'/>},
  // {'id': constants.activity.types.VISITOR_OPINION, 'name': <FormattedMessage id='activity.type.opinion'/>},
  // {'id': constants.activity.types.QUESTIONNAIRE, 'name': <FormattedMessage id='activity.type.questionnaire'/>},
  // {'id': constants.activity.types.SURVEY, 'name': <FormattedMessage id='activity.type.survey'/>},
  {'id': constants.activity.types.CHALLENGE, 'name': <FormattedMessage id='activity.type.challenge'/>},
  {'id': constants.activity.types.SLIDES, 'name': <FormattedMessage id='activity.type.slides'/>},
  {'id': constants.activity.types.SHOWCASE_MENU, 'name': <FormattedMessage id='activity.type.showcaseMenu'/>},
];

export const ACTIVITY_TYPES_REWARD_MODEL = [
  {'id': constants.activity.types.OFFER, 'name': <FormattedMessage id='activity.type.offer'/>},
  {'id': constants.activity.types.VOUCHER, 'name': <FormattedMessage id='activity.type.voucher'/>},
];

export const ACTIVITY_USAGE_TYPES_MODEL = [
  {'id': constants.activity.usageTypes.MARKETING, 'name': <FormattedMessage id='activity.usageType.branding'/>, 'details': <FormattedMessage id='activity.usageType.dbranding'/>, 'image': require('src/images/img_usage_type_branding.png'), addButtonId: 'generic.addMarketingCampaign'},
  {'id': constants.activity.usageTypes.TRAINING, 'name': <FormattedMessage id='activity.usageType.employee'/>, 'details': <FormattedMessage id='activity.usageType.demployee'/>, 'image': require('src/images/img_usage_type_employee.png'), addButtonId: 'generic.addTrainingCampaign'},
  // {'id': constants.activity.usageTypes.LOYALTY, 'name': <FormattedMessage id='activity.usageType.loyalty'/>, 'details': <FormattedMessage id='activity.usageType.dloyalty'/>, 'image': require('src/images/img_usage_type_loyalty.png'), addButtonId: 'generic.addLoyaltyCampaign'},
  {'id': constants.activity.usageTypes.EDUCATION, 'name': <FormattedMessage id='activity.usageType.school'/>, 'details': <FormattedMessage id='activity.usageType.dschool'/>, 'image': require('src/images/img_usage_type_school.png'), addButtonId: 'generic.addEducationCampaign'},
  {'id': constants.activity.usageTypes.SOCIAL, 'name': <FormattedMessage id='activity.usageType.party'/>, 'details': <FormattedMessage id='activity.usageType.dparty'/>, 'image': require('src/images/img_usage_type_party.png'), addButtonId: 'generic.addSocialCampaign'},
  {'id': constants.activity.usageTypes.INFLUENCER, 'name': <FormattedMessage id='activity.usageType.influencer'/>, 'details': <FormattedMessage id='activity.usageType.dinfluencer'/>, 'image': require('src/images/img_usage_type_influencer.png'), addButtonId: 'generic.addInfluencerCampaign'},
];

const GetViewForItem = React.memo((props) => {
  const {item, index, itemWidth, isLTR, classes, isXS, isFirst, isLast} = props;
  const {onClickViewCampaign, onClickLink, onClickInsight, onClickPromote, onClickEdit,
    onClickMore, onClickAnswerDistribution, onClickActivityReviews} = props;
  const isListC2Up = itemWidth > 1000;
  const alignFlexColumn = ALIGN_DIR === 'left' ? classes.flexColumnNoCenter : classes.flexColumn;

  const isItemReward = item.type === constants.activity.types.OFFER
    || item.type === constants.activity.types.DISCOUNT
    || item.type === constants.activity.types.VOUCHER;

  // const viewsCountText = ValueHelper.getDisplayValue(item.displayedCount, 2, true, true);
  const viewsCountText = ValueHelper.getDisplayValue(item.viewsCount, 2, true, true);
  // let actionsCount = item.consumedCount;
  // if (item.type == constants.activity.types.SMART_AD
  //   || item.type == constants.activity.types.BUYER_OPINION
  //   || item.type == constants.activity.types.VISITOR_OPINION
  //   || item.type == constants.activity.types.EVENT
  // ) {
  //   actionsCount = ValueHelper.getDisplayValue(item.clickedCount);
  // } else if (item.type == constants.activity.types.CHALLENGE || item.type == constants.activity.types.SOCIAL_CONTENT) {
  //   actionsCount = ValueHelper.getDisplayValue(item.commentsCount);
  // }
  // const actionsCountText = ValueHelper.getDisplayValue(actionsCount, 2, true, true);
  const actionsCountText = ValueHelper.getDisplayValue(item.actionsCount, 2, true, true);

  let actionsTitleId = null;
  if (isItemReward) {
    actionsTitleId = 'campaign.consumes';
  } else {
    // actionsTitleId = 'campaign.plays';
    actionsTitleId = 'campaign.actions';
  }

  const hasNoPlan = !item.ad || item.ad.planType <= constants.activity.plans.NO_PLAN;
  const hasFreePlan = item.ad && item.ad.planType === constants.activity.plans.FREE_PLAN;
  const isPlanEnded = isCurrentPlanEnded(item.ad);
  let promoteButtonTooltipId = 'activity.manage.tooltipExtend';
  let promoteButtonId = 'activity.manage.actionExtend';
  let promoteButtonStart = require('src/images/ic_timer.png');
  let promoteButtonClassname = classes.promoteGreenButton;
  if (hasNoPlan) {
    promoteButtonTooltipId = 'activity.manage.tooltipSubscribe';
    promoteButtonId = 'activity.manage.actionSubscribe';
    promoteButtonStart = null;
    promoteButtonClassname = classes.promoteRedButton;
  } else if (hasFreePlan) {
    promoteButtonTooltipId = 'activity.manage.tooltipUpgrade';
    promoteButtonId = 'activity.manage.actionUpgrade';
    promoteButtonStart = null;
    promoteButtonClassname = classes.promoteGreenButton;
  } else if (isPlanEnded) {
    promoteButtonTooltipId = 'activity.manage.tooltipRenew';
    promoteButtonId = 'activity.manage.actionRenew';
    promoteButtonStart = require('src/images/ic_refresh.png');
    promoteButtonClassname = classes.promoteRedButton;
  }

  let stateTextId = null;
  let stateTextColor = null;
  let hideElevation = false;
  if (item.state == constants.activity.state.ACTIVE) {
    if (isItemReward) {
      stateTextId = 'campaign.active';
      stateTextColor = ColorActive;
    } else {
      if (hasNoPlan) {
        stateTextId = 'campaign.noPlan';
        stateTextColor = ColorInactive;
        // hideElevation = true;
      } else if (isPlanEnded) {
        stateTextId = 'generic.ended';
        stateTextColor = ColorInactive;
        // hideElevation = true;
      } else if (isCurrentPlanViewEnded(item.ad)) {
        stateTextId = 'campaign.viewsOver';
        stateTextColor = ColorOrange;
        // hideElevation = true;
      } else {
        stateTextId = 'campaign.active';
        stateTextColor = ColorActive;
      }
    }
  } else if (item.state == constants.activity.state.INACTIVE) {
    stateTextId = 'campaign.inactive';
    stateTextColor = ColorOrange;
    // hideElevation = true;
  } else if (item.state == constants.activity.state.REJECTED) {
    stateTextId = 'campaign.suspended';
    stateTextColor = ColorNegative;
    // hideElevation = true;
  }

  const startDateDiff = DateTimeHelper.getSecondsDiffFromNow(item.startAt);
  const endDateDiff = DateTimeHelper.getSecondsDiffFromNow(item.endAt);
  let startText = null;
  let startColor = ColorTitleLite;
  if (startDateDiff <= 0) {
    if (endDateDiff <= 0) {
      // startText = <FormattedMessage id='campaign.finished' />;
      startText = DateTimeHelper.getSince(item.startAt, 'time.since');
    } else {
      startText = <FormattedMessage id='campaign.live' />;
    }
  } else {
    startText = DateTimeHelper.getValidityInTime(item.startAt);
  }
  let endText = null;
  let endColor = ColorTitleLite;
  if (endDateDiff <= 0) {
    endText = <FormattedMessage id='generic.ended' />;
  } else {
    endText = DateTimeHelper.getValidityInTime(item.endAt);
  }
  if (!isItemReward && isCurrentPlanNoPlan(item.ad)) {
    endText = <FormattedMessage id='activity.plan.dateNoSet' />;
  }

  // let validityText = null;
  // let validityTextEx = null;
  // let validityColor = ColorTitleLite;
  // if (startDateDiff <= 0) {
  //   const endDateDiff = DateTimeHelper.getSecondsDiffFromNow(item.endAt);
  //   if (endDateDiff <= 0) {
  //     validityText = <FormattedMessage id='generic.ended' />;
  //     // validityColor = ColorOrange;
  //   } else {
  //     validityText = <FormattedMessage id='generic.endingInTime' />;
  //     // validityColor = ColorActive;
  //     validityTextEx = DateTimeHelper.getValidity(item.endAt);
  //   }
  // } else {
  //   validityText = <FormattedMessage id='generic.startingInTime' />;
  //   // validityColor = ColorTitleLite;
  //   validityTextEx = DateTimeHelper.getValidity(item.startAt);
  // }
  // if (!isItemReward && isCurrentPlanNoPlan(item.ad)) {
  //   // validityColor = ColorOtherTitle;
  //   validityText = <FormattedMessage id='activity.plan.dateNoSet' />;
  //   validityTextEx = null;
  // }

  let type = null;
  ACTIVITY_TYPES_MODEL.forEach((activityType) => {
    if (activityType.id === item.type) {
      if (item.type === constants.activity.types.EXTERNAL_GAMES) {
        type = item.gameInfo.name;
      } else {
        type = activityType.name;
      }
      if (isXS) {
        if (item.type === constants.activity.types.GAME_SPIN_N_DISCOVER) {
          type = <FormattedMessage id={'campaign.typeSpinDiscoverShort'}/>
        }
      }
    }
  });


  const onClickViewCampaignL = () => {
    onClickViewCampaign(item);
  };
  const onClickAnswerDistributionL = () => {
    onClickAnswerDistribution(item);
  };
  const onClickActivityReviewsL = () => {
    onClickActivityReviews(item);
  };
  const onClickLinkL = () => {
    onClickLink(item);
  };
  const onClickInsightL = () => {
    onClickInsight(item);
  };
  const onClickPromoteL = () => {
    onClickPromote(item);
  };
  const onClickEditL = () => {
    onClickEdit(item);
  };
  const onClickMoreL = (event) => {
    onClickMore(item, index, event.currentTarget);
  };

  const isQuestion = item.type === constants.activity.types.QUESTION || item.questionId > 0;
  const isOpinion = item.type === constants.activity.types.VISITOR_OPINION;
  // const showActionBrief = isQuestion || isOpinion;
  const showActionBrief = false;

  const styleFlip = isLTR ? {} : {
    '-moz-transform': 'scaleX(-1)',
    '-webkit-transform': 'scaleX(-1)',
    '-o-transform': 'scaleX(-1)',
    'transform': 'scaleX(-1)',
    '-ms-filter': 'fliph',
    'filter': 'fliph',
  }
  const styleAlignRight = !isXS || isLTR ? {} : {
    justifyContent: 'flex-end',
  }
  const borderStyle = {
    borderBottomLeftRadius: isLast || isXS ? BORDER_RADIUS : 0,
    borderBottomRightRadius: isLast || isXS ? BORDER_RADIUS : 0,
    borderTopLeftRadius: isFirst || isXS ? BORDER_RADIUS : 0,
    borderTopRightRadius: isFirst || isXS ? BORDER_RADIUS : 0,
  }
  const imageWidth = isXS || !isListC2Up ? 52 : 56;
  const showType = isXS || isListC2Up;
  let imageUrl = item.imageUrl;
  if (!item.demo) {
    if (!isItemReward && item.rewardImageUrl && (!item.imageUrl || item.imageUrl === ApiHelper.getActivityDefaultImageUrl(item.type, item.subType, item.gameInfo))) {
      imageUrl = item.rewardImageUrl;
    }
    if (!imageUrl && item.type === constants.activity.types.EXTERNAL_GAMES) {
      imageUrl = item.gameInfo.imageUrl;
    }
  } else {
    imageUrl = require('src/images/img_demo.webp');
  }

  return (
    <Paper elevation={isXS ? 1 : 1} key={''+ item.id} className={classes.cardItemWrapper} style={{backgroundColor: item.demo ? '#FFF6F6' : ColorCard, ...borderStyle}}>
      <div className={classes.cardItem} style={borderStyle}>
        {/*<ButtonBase className={classes.buttonBaseApp}>*/}
        <div className={isXS ? classes.cardItemContentXS : (isItemReward ? (isLTR ? classes.cardItemContentOffers : classes.cardItemContentOffersRTL) : (isLTR ? classes.cardItemContent : classes.cardItemContentRTL))} style={styleFlip} onClick={() => {}}>
          {/*<div style={{display: 'flex', flexDirection: 'column'}}>*/}
            {/*<div style={{display: 'flex', flexDirection: 'row'}}>*/}
            {/*  <div style={{paddingLeft: 8, paddingRight: 8, borderRadius: BORDER_RADIUS, backgroundColor: ColorThemeYellowLite}}>*/}
            {/*    <Typography variant="caption" style={{color: ColorTitle, fontWeight: 'bold'}}>*/}
            {/*      {'#'+ item.id}*/}
            {/*    </Typography>*/}
            {/*  </div>*/}
            {/*</div>*/}
            {/*<Space horizontal={6} />*/}
          {/*  <img src={item.imageUrl} className={classes.cardImage} width={imageWidth} height={imageWidth/4*3} />*/}
          {/*</div>*/}
          {/*<Space verticalSpace={1.5} />*/}

          {/*<div className={isXS ? classes.cardItemContentXS : (isItemReward ? classes.cardItemContentOffers : classes.cardItemContent)} style={styleFlip}>*/}
            <div className={classes.cardItemContentPart1} style={{flex: isXS ? 1 : .9}}>
              <div className={classes.flexRow} style={{flex: 1}}>
                <img alt={".֎."} src={imageUrl} className={classes.cardImage} width={imageWidth} height={imageWidth/4*3} style={{objectFit: 'contain', ...styleFlip}} />
                <Space verticalSpace={1} />
                <div className={isListC2Up ? classes.flexRow : classes.flexColumnNoCenter} style={{flex: 1}}>
                  <div className={classes.viewColumn} style={{flex: isListC2Up ? .8 : 1, ...styleFlip}}>
                    <TextView variant="body2" color={'textPrimary'} textAlign={'left'} fontWeight={FONT_WEIGHT_MEDIUM} numberOfLines={2}>
                      {item.title}
                    </TextView>
                  </div>
                  {isListC2Up ? <Space verticalSpace={1} /> : null}
                  {isListC2Up ?
                    <div className={classes.viewColumn} style={{flex: isListC2Up ? .3 : 1, minWidth: 90, ...styleFlip}}>
                      <Typography variant={"body2"} align={isListC2Up ? ALIGN_DIR : 'left'} style={{color: ColorSubTitle}}>
                        {type}
                      </Typography>
                    </div>
                    : null
                  }
                </div>
                {isXS ?
                  <React.Fragment>
                    <Space verticalSpace={1} />
                    <IconButton
                      color={'primary'}
                      className={classes.moreButtonXS}
                      onClick={onClickMoreL}>
                      <AppIcon icon={IconMoreH} color={ColorSubTitle} />
                    </IconButton>
                  </React.Fragment>
                  : null
                }
              </div>
            </div>
            <Space verticalSpace={1} />

            <div className={isXS ? classes.flexColumn : classes.cardItemContentPart2} style={{flex: isXS ? 1 : 1.1, minWidth: isXS ? 240 : 400, paddingTop: isXS ? 16 : 0}}>
              <div className={isXS ? classes.flexRow : classes.viewRow} style={{flex: isXS ? 1 : .4, minWidth: isXS ? 0 : 188}}>
                {isXS ?
                  <React.Fragment>
                    <div className={alignFlexColumn} style={{flex: .5, minWidth: 90, ...styleFlip, ...styleAlignRight}}>
                      {isXS ?
                        <Typography variant="caption" align={ALIGN_DIR} className={classes.typoNormal} style={{color: ColorSecondary, marginBottom: 2}}>
                          {<FormattedMessage id={'activity.manage.type'} />}
                        </Typography>
                        : null
                      }
                      <TextView numberOfLines={1} variant={"body2"} fontWeight={FONT_WEIGHT_MEDIUM} style={{color: ColorTitleLite}} align={ALIGN_DIR}>
                        {type}
                      </TextView>
                    </div>
                    <Divider light orientation={'vertical'} style={{marginLeft: 4, marginRight: 4}}/>
                  </React.Fragment>
                  : null
                }
                <div className={alignFlexColumn} style={{flex: .5, minWidth: 90, ...styleFlip, ...styleAlignRight}}>
                  {isXS ?
                    <Typography variant="caption" align={ALIGN_DIR} className={classes.typoNormal} style={{color: ColorSecondary, marginBottom: 2}}>
                      {<FormattedMessage id={'campaign.start'} />}
                    </Typography>
                    : null
                  }
                  <TextView numberOfLines={1} variant={"body2"} className={isXS ? classes.typoMedium : classes.typoNormal} style={{color: startColor, wordBreak: 'break-all'}} align={ALIGN_DIR}>
                    {startText}
                  </TextView>
                </div>
                {isXS ?
                  <Divider light orientation={'vertical'} style={{marginLeft: 4, marginRight: 4}}/>
                  : <Space verticalSpace={1} />
                }
                <div className={alignFlexColumn} style={{flex: .5, minWidth: 90, marginTop: isXS ? 0 : 0, ...styleFlip, ...styleAlignRight}}>
                  {isXS ?
                    <Typography variant="caption" align={ALIGN_DIR} className={isXS ? classes.typoNormal : classes.typoNormal} style={{color: ColorSecondary, marginBottom: 2}}>
                      {<FormattedHTMLMessage id={'campaign.end'} />}
                    </Typography>
                    : null
                  }
                  <TextView numberOfLines={1} variant={"body2"} className={isXS ? classes.typoMedium : classes.typoNormal} style={{color: endColor, wordBreak: 'break-all'}} align={ALIGN_DIR}>
                    {endText}
                  </TextView>
                </div>
              </div>

              {isXS ?
                <Divider light orientation={'horizontal'}  style={{width: '100%', margin: 16, marginTop: 8, marginBottom: 8}}/>
                : <Space verticalSpace={1} />
              }

              <div className={isXS ? classes.flexRow : classes.viewRow} style={{flex: isXS ? 1 : .6, minWidth: isXS ? 0 : 188}}>
                <div className={alignFlexColumn} style={{flex: 1, minWidth: isXS ? 0 : 62, alignItems: 'center'}}>
                  {isXS ?
                    <Typography variant="caption" align={ALIGN_DIR} className={isXS ? classes.typoNormal : classes.typoNormal} style={{color: ColorSecondary, marginBottom: 2, ...styleFlip}}>
                      {<FormattedMessage id={'campaign.views'} />}
                    </Typography>
                    : null
                  }
                  <Typography variant={"body2"} align={ALIGN_DIR} className={isXS ? classes.typoMedium : classes.typoNormal} style={{width: '100%', color: ColorTitleLite, ...styleFlip}}>
                    {viewsCountText}
                  </Typography>
                </div>

                {isXS ?
                  <Divider light orientation={'vertical'} style={{marginLeft: 4, marginRight: 4}}/>
                  : <Space verticalSpace={1} />
                }

                <div className={alignFlexColumn} style={{flex: 1, minWidth: isXS ? 0 : 62, alignItems: 'center'}}>
                  {isXS ?
                    <Typography variant="caption" align={ALIGN_DIR} className={isXS ? classes.typoNormal : classes.typoNormal} style={{color: ColorSecondary, marginBottom: 2, ...styleFlip}}>
                      {<FormattedMessage id={actionsTitleId} />}
                    </Typography>
                    : null
                  }
                  <Typography variant="body2" align={ALIGN_DIR} className={isXS ? classes.typoMedium : classes.typoNormal} style={{width: '100%', color: ColorTitleLite, ...styleFlip}}>
                    {actionsCountText}
                  </Typography>
                </div>

                {isXS ?
                  <Divider light orientation={'vertical'} style={{marginLeft: 4, marginRight: 4}}/>
                  : <Space verticalSpace={1} />
                }

                <div className={alignFlexColumn} style={{flex: 1, alignItems: 'center'}}>
                  {isXS ?
                    <Typography variant="caption" align={ALIGN_DIR} className={isXS ? classes.typoNormal : classes.typoNormal} style={{color: ColorSecondary, marginBottom: 2, ...styleFlip}}>
                      {<FormattedMessage id={'campaign.status'} />}
                    </Typography>
                    : null
                  }
                  <Typography variant="body2" align={ALIGN_DIR} className={isXS ? classes.typoMedium : classes.typoNormal} style={{color: stateTextColor, ...styleFlip}}>
                    {<FormattedMessage id={stateTextId} />}
                  </Typography>
                </div>
              </div>
            </div>
          {/*</div>*/}

          {isXS ?
            <div className={classes.viewColumnFullWidth} style={{marginTop: 14}}>
              {/*{!isItemReward && !hasNoPlan ?*/}
              {!isItemReward ?
                <div className={classes.viewRowFullWidth} style={{marginBottom: 10, paddingLeft:1, paddingRight: 1}}>
                  {!showActionBrief ?
                    <Button
                      fullWidth
                      disableElevation
                      size={'medium'}
                      variant={'outlined'}
                      color={'secondary'}
                      style={{...styleFlip}}
                      onClick={onClickViewCampaignL}>
                      <div className={classes.viewRow}>
                        {isLTR ? <ImageIcon src={require('src/images/ic_open_out_black.png')} width={17} height={17} style={{marginRight: 6}} /> : null}
                        {<FormattedMessage id={'activity.open'} />}
                        {!isLTR ? <ImageIcon src={require('src/images/ic_open_out_black.png')} width={17} height={17} style={{marginLeft: 6}} /> : null}
                      </div>
                    </Button>
                    : null
                  }
                  {showActionBrief && isQuestion ?
                    <Button
                      fullWidth
                      disableElevation
                      size={'medium'}
                      variant={'outlined'}
                      color={'secondary'}
                      style={{...styleFlip}}
                      onClick={onClickAnswerDistributionL}>
                      <div className={classes.viewRow}>
                        {isLTR ? <ImageIcon src={require('src/images/ic_poll_result_h.png')} width={16} height={16} style={{marginRight: 6}} /> : null}
                        {<FormattedMessage id={'activity.viewAnswersS'} />}
                        {!isLTR ? <ImageIcon src={require('src/images/ic_poll_result_h.png')} width={16} height={16} style={{marginLeft: 6}} /> : null}
                      </div>
                    </Button>
                    : null
                  }
                  {showActionBrief && !isQuestion && isOpinion ?
                    <Button
                      fullWidth
                      disableElevation
                      size={'medium'}
                      variant={'outlined'}
                      color={'secondary'}
                      style={{...styleFlip}}
                      onClick={onClickActivityReviewsL}>
                      <div className={classes.viewRow}>
                        {isLTR ? <ImageIcon src={require('src/images/ic_poll_result_h.png')} width={16} height={16} style={{marginRight: 6}} /> : null}
                        {<FormattedMessage id={'activity.viewOpinionsS'} />}
                        {!isLTR ? <ImageIcon src={require('src/images/ic_poll_result_h.png')} width={16} height={16} style={{marginLeft: 6}} /> : null}
                      </div>
                    </Button>
                    : null
                  }
                  {/*<Button*/}
                  {/*  fullWidth*/}
                  {/*  disableElevation*/}
                  {/*  size={'medium'}*/}
                  {/*  variant={'outlined'}*/}
                  {/*  color={'secondary'}*/}
                  {/*  style={{marginLeft: 10, marginRight: 10, ...styleFlip}}*/}
                  {/*  onClick={onClickInsightL}>*/}
                  {/*  <div className={classes.viewRow}>*/}
                  {/*    {isLTR ? <ImageIcon src={require('src/images/ic_insight.png')} width={14} height={14} style={{marginRight: 6}} /> : null}*/}
                  {/*    {<FormattedMessage id={'activity.insightS'} />}*/}
                  {/*    {!isLTR ? <ImageIcon src={require('src/images/ic_insight.png')} width={14} height={14} style={{marginLeft: 6}} /> : null}*/}
                  {/*  </div>*/}
                  {/*</Button>*/}
                  <Button
                    fullWidth
                    disableElevation
                    size={'medium'}
                    variant={'outlined'}
                    color={'secondary'}
                    style={{marginLeft: 10, ...styleFlip}}
                    onClick={onClickLinkL}>
                    <div className={classes.viewRow}>
                      {isLTR ? <ImageIcon src={require('src/images/ic_share.png')} width={16} height={16} style={{marginRight: 6}} /> : null}
                      {<FormattedMessage id={'activity.share'} />}
                      {!isLTR ? <ImageIcon src={require('src/images/ic_share.png')} width={16} height={16} style={{marginLeft: 6}} /> : null}
                    </div>
                  </Button>
                </div>
                : null
              }

              {!isItemReward ?
                // <div
                //   className={promoteButtonClassname}
                //   style={{display: 'flex', flexDirection: 'row', flex: 1, width: '100%', minHeight: 36, justifyContent: 'center'}}
                // >
                //   <div className={classes.flexGrow}/>
                //   {isLTR && promoteButtonStart ? <ImageIcon src={promoteButtonStart} width={16} height={16} style={{marginRight: 6}} /> : null}
                //   <TextView><FormattedMessage id={promoteButtonId} /></TextView>
                //   {!isLTR && promoteButtonStart ? <ImageIcon src={promoteButtonStart} width={16} height={16} style={{marginLeft: 6}} /> : null}
                //   <div className={classes.flexGrow}/>
                // </div>
                <Button
                  fullWidth
                  disableElevation
                  size={'medium'}
                  variant={'contained'}
                  className={promoteButtonClassname}
                  onClick={onClickPromoteL}
                  style={{maxWidth: 600, ...styleFlip}}>
                  <div className={classes.viewRow}>
                    {isLTR && promoteButtonStart ? <ImageIcon src={promoteButtonStart} width={16} height={16} style={{marginRight: 6}} /> : null}
                    {<FormattedMessage id={promoteButtonId} />}
                    {!isLTR && promoteButtonStart ? <ImageIcon src={promoteButtonStart} width={16} height={16} style={{marginLeft: 6}} /> : null}
                  </div>
                </Button>
                : null
              }
              {isItemReward ?
                <Button
                  fullWidth
                  disableElevation
                  size={'medium'}
                  variant={'contained'}
                  className={classes.editButton}
                  style={{maxWidth: 600, ...styleFlip}}
                  onClick={onClickEditL}>
                  <div className={classes.viewRow}>
                    {isLTR ? <ImageIcon src={require('src/images/ic_edit_t.png')} width={16} height={16} style={{marginRight: 6}} /> : null}
                    {<FormattedMessage id={'generic.edit'} />}
                    {!isLTR ? <ImageIcon src={require('src/images/ic_edit_t.png')} width={16} height={16} style={{marginLeft: 6}} /> : null}
                  </div>
                </Button>
                : null
              }
            </div>
            : null
          }

          {!isXS ?
            <div className={(isItemReward ? (isLTR ? classes.cardItemActionWrapperOffers : classes.cardItemActionWrapperOffersRTL) : (isLTR ? classes.cardItemActionWrapper : classes.cardItemActionWrapperRTL))}>
              {!isItemReward ?
                <FormattedMessage id={promoteButtonTooltipId}>
                  {title => (
                    <Tooltip title={title}>
                      <Button
                        disableElevation
                        size={'medium'}
                        variant={'contained'}
                        className={promoteButtonClassname}
                        style={{marginRight: 8, ...styleFlip}}
                        onClick={onClickPromoteL}>
                        <div className={classes.viewRow}>
                          {isLTR && promoteButtonStart ? <ImageIcon src={promoteButtonStart} width={16} height={16} style={{marginRight: 6}} /> : null}
                          {<FormattedMessage id={promoteButtonId} />}
                          {!isLTR && promoteButtonStart ? <ImageIcon src={promoteButtonStart} width={16} height={16} style={{marginLeft: 6}} /> : null}
                        </div>
                      </Button>
                    </Tooltip>
                  )}
                </FormattedMessage>
                : null
              }
              {isItemReward ?
                <FormattedMessage id='tooltip.action.edit'>
                  {title => (
                    <Tooltip title={title}>
                      <Button
                        disableElevation
                        size={'medium'}
                        variant={'contained'}
                        className={classes.editButton}
                        style={{marginRight: 8, ...styleFlip}}
                        onClick={onClickEditL}>
                        <div className={classes.viewRow}>
                          {isLTR ? <ImageIcon src={require('src/images/ic_edit_t.png')} width={16} height={16} style={{marginRight: 6}} /> : null}
                          {<FormattedMessage id={'generic.edit'} />}
                          {!isLTR ? <ImageIcon src={require('src/images/ic_edit_t.png')} width={16} height={16} style={{marginLeft: 6}} /> : null}
                        </div>
                      </Button>
                    </Tooltip>
                  )}
                </FormattedMessage>
                : null
              }

              <FormattedMessage id='tooltip.action.more'>
                {title => (
                  <Tooltip title={title}>
                    <IconButton
                      color={'primary'}
                      className={classes.moreButton}
                      onClick={onClickMoreL}
                      style={{marginLeft: 6}}>
                      <AppIcon icon={IconMoreH} color={ColorSubTitle} />
                    </IconButton>
                  </Tooltip>
                )}
              </FormattedMessage>
            </div>
            : null
          }
        </div>
      </div>
    </Paper>
  );
});

const MenuView = React.memo((props) => {
  const {item, index, classes, isXS, showMenu, showMenuElement} = props;
  const {onClickPromote, onClickEdit, onCloseMore, onClickToggleItem, onClickDeleteItem,
    onClickViewPlan, onClickInsight, onClickAnswerDistribution, onClickGuessDistribution, onClickActivityReviews,
    onClickViewCampaign, onClickLink, onClickShowWinners, onClickDeclareWinners,
    onClickEndCampaign} = props;

  const isItemReward = item.type === constants.activity.types.OFFER
    || item.type === constants.activity.types.DISCOUNT
    || item.type === constants.activity.types.VOUCHER;

  const hasNoPlan = !item.ad || item.ad.planType <= constants.activity.plans.NO_PLAN;
  const hasFreePlan = item.ad && item.ad.planType === constants.activity.plans.FREE_PLAN;
  const isPlanEnded = isCurrentPlanEnded(item.ad);
  let promoteButtonId = 'activity.manage.actionExtend';
  if (hasNoPlan) {
    promoteButtonId = 'activity.manage.actionSubscribe';
  } else if (hasFreePlan) {
    promoteButtonId = 'activity.manage.actionUpgrade';
  } else if (isPlanEnded) {
    promoteButtonId = 'activity.manage.actionRenew';
  }

  const onClickPromoteL = () => {
    onClickPromote(item);
  };
  const onClickEditL = () => {
    onClickEdit(item);
  };
  const onCloseMoreL = () => {
    onCloseMore();
  };
  const onClickToggleItemL = () => {
    onClickToggleItem(item);
  };
  const onClickDeleteItemL = () => {
    onClickDeleteItem(item, index);
  };
  const onClickDeclareWinnersL = () => {
    onClickDeclareWinners(item);
  };
  const onClickEndCampaignL = () => {
    onClickEndCampaign(item);
  };
  const onClickViewPlanL = () => {
    onClickViewPlan(item);
  };
  const onClickInsightL = () => {
    onClickInsight(item);
  };
  const onClickAnswerDistributionL = () => {
    onClickAnswerDistribution(item);
  };
  const onClickGuessDistributionL = () => {
    onClickGuessDistribution(item);
  };
  const onClickShowWinnersL = () => {
    onClickShowWinners(item);
  };
  const onClickActivityReviewsL = () => {
    onClickActivityReviews(item);
  };
  const onClickViewCampaignL = () => {
    onClickViewCampaign(item);
  };
  const onClickLinkL = () => {
    onClickLink(item);
  };

  // const isQuestion = item.type === constants.activity.types.QUESTION || item.questionId > 0;
  // const isOpinion = item.type === constants.activity.types.VISITOR_OPINION;
  // const showOpen = !isItemReward && !hasNoPlan && (!isXS || isQuestion || isOpinion);
  // const showShare = !isItemReward && !hasNoPlan && !isXS;
  // const showActionQuestion = !isXS;
  // const showActionOpinion = !isXS || isQuestion;

  // const showOpen = !isItemReward && !hasNoPlan && !isXS;
  // const showShare = !isItemReward && !hasNoPlan && !isXS;
  const showOpen = !isItemReward && !isXS;
  const showShare = !isItemReward && !isXS && item.type !== constants.activity.types.SHOWCASE_MENU;
  const showActionQuestion = true;
  const showActionOpinion = true;

  return (
    <Menu
      id="menu"
      anchorEl={showMenuElement}
      getContentAnchorEl={null}
      anchorOrigin={{vertical: 'bottom', horizontal: 'center'}}
      transformOrigin={{vertical: 'top', horizontal: 'center'}}
      open={showMenu}
      onClose={onCloseMoreL}>
      {/*{isXS && !isItemReward ?*/}
      {/*  <MenuItem dense onClick={onClickPromoteL}>*/}
      {/*    <div className={classes.menuItemBox}>*/}
      {/*      <PromoteIcon color={'primary'} fontSize={'small'} />*/}
      {/*      <Space verticalSpace={1.2} />*/}
      {/*      <Typography color={'textPrimary'} variant={'body1'}>*/}
      {/*        <FormattedMessage id={promoteButtonId} />*/}
      {/*      </Typography>*/}
      {/*    </div>*/}
      {/*  </MenuItem>*/}
      {/*  : null*/}
      {/*}*/}

      {showOpen ?
        <MenuItem dense onClick={onClickViewCampaignL}>
          <div className={classes.menuItemBox}>
            <ImageIcon src={require('src/images/ic_open_out_black.png')} />
            <Space verticalSpace={1.2} />
            <Typography variant={'body2'} color={'textPrimary'}>
              <FormattedMessage id='activity.openCampaign' />
            </Typography>
          </div>
        </MenuItem>
        : null
      }
      {showShare ?
        <MenuItem dense onClick={onClickLinkL}>
          <div className={classes.menuItemBox}>
            <ImageIcon src={require('src/images/ic_share.png')} width={16} height={16}/>
            <Space verticalSpace={1.2} />
            <Typography variant={'body2'} color={'textPrimary'}>
              <FormattedMessage id={'activity.manage.shareLink'} />
            </Typography>
          </div>
        </MenuItem>
        : null
      }
      {showOpen || showShare ?
        <Divider style={{width: '100%', height: 1, marginTop: 8, marginBottom: 8, color: '#E8EEFA'}} />
        : null
      }

      {!isItemReward ?
        <MenuItem dense onClick={onClickEditL}>
          <div className={classes.menuItemBox}>
            <ImageIcon src={require('src/images/ic_edit.png')} />
            <Space verticalSpace={1.2} />
            <Typography color={'textPrimary'} variant={'body2'}>
              <FormattedMessage id='campaign.edit' />
            </Typography>
          </div>
        </MenuItem>
        : null
      }
      {item.state === constants.activity.state.ACTIVE && (isItemReward || (!hasNoPlan && !isPlanEnded)) ?
        <MenuItem dense onClick={onClickToggleItemL}>
          <div className={classes.menuItemBox}>
            <ImageIcon src={require('src/images/ic_toggle_off.png')} />
            <Space verticalSpace={1.2} />
            <Typography variant={'body2'} style={{color: ColorOrange}}>
              <FormattedMessage id='campaign.deactivate' />
            </Typography>
          </div>
        </MenuItem>
        : null
      }
      {item.state === constants.activity.state.INACTIVE ?
        <MenuItem dense onClick={onClickToggleItemL}>
          <div className={classes.menuItemBox}>
            <ImageIcon src={require('src/images/ic_toggle_on.png')} />
            <Space verticalSpace={1.2} />
            <Typography variant={'body2'} style={{color: ColorActive}}>
              <FormattedMessage id='campaign.activate' />
            </Typography>
          </div>
        </MenuItem>
        : null
      }
      <MenuItem dense onClick={onClickDeleteItemL}>
        <div className={classes.menuItemBox}>
          <ImageIcon src={require('src/images/ic_delete.png')} />
          <Space verticalSpace={1.2} />
          <Typography color={'error'} variant={'body2'}>
            <FormattedMessage id='campaign.delete' />
          </Typography>
        </div>
      </MenuItem>
      {!isItemReward && !hasNoPlan && item.type !== constants.activity.types.SHOWCASE_MENU ?
        <Divider style={{width: '100%', height: 1, marginTop: 8, marginBottom: 8, color: '#E8EEFA'}} />
        : null
      }

      {!isItemReward && !hasNoPlan && item.type !== constants.activity.types.SHOWCASE_MENU ?
        <MenuItem dense onClick={onClickViewPlanL}>
          <div className={classes.menuItemBox}>
            <ImageIcon src={require('src/images/ic_view.png')} />
            <Space verticalSpace={1.2} />
            <Typography variant={'body2'} color={'textPrimary'}>
              <FormattedMessage id='activity.manage.viewCampaignPlan' />
            </Typography>
          </div>
        </MenuItem>
        : null
      }
      {(item.type === constants.activity.types.GUESS) && !hasNoPlan ?
        <MenuItem dense onClick={onClickGuessDistributionL}>
          <div className={classes.menuItemBox}>
            <ImageIcon src={require('src/images/ic_guess_result.png')} style={{padding: 1}} />
            <Space verticalSpace={1.2} />
            <Typography variant={'body2'} color={'textPrimary'}>
              <FormattedMessage id='activity.guessDistribution' />
            </Typography>
          </div>
        </MenuItem>
        : null
      }
      {(item.type === constants.activity.types.QUESTION || item.questionId > 0) && !hasNoPlan && showActionQuestion ?
        <MenuItem dense onClick={onClickAnswerDistributionL}>
          <div className={classes.menuItemBox}>
            <ImageIcon src={require('src/images/ic_poll_result_h.png')} style={{padding: 2}} />
            <Space verticalSpace={1.2} />
            <Typography variant={'body2'} color={'textPrimary'}>
              <FormattedMessage id='activity.answerDistribution' />
            </Typography>
          </div>
        </MenuItem>
        : null
      }
      {item.type === constants.activity.types.VISITOR_OPINION && !hasNoPlan && showActionOpinion ?
        <MenuItem dense onClick={onClickActivityReviewsL}>
          <div className={classes.menuItemBox}>
            <ImageIcon src={require('src/images/ic_poll_result_h.png')} style={{padding: 2}} />
            <Space verticalSpace={1.2} />
            <Typography variant={'body2'} color={'textPrimary'}>
              <FormattedMessage id='activity.viewOpinions' />
            </Typography>
          </div>
        </MenuItem>
        : null
      }
      {!isItemReward && !hasNoPlan && item.showWinners ?
        <MenuItem dense onClick={onClickShowWinnersL}>
          <div className={classes.menuItemBox}>
            <ImageIcon src={require('src/images/ic_winners.png')} style={{padding: 2}} />
            <Space verticalSpace={1.2} />
            <Typography variant={'body2'} color={'textPrimary'}>
              <FormattedMessage id='winners' />
            </Typography>
          </div>
        </MenuItem>
        : null
      }
      {/*{!isXS && !isItemReward && !hasNoPlan ?*/}
      {/*{!isXS && !isItemReward ?*/}
      {/*  <MenuItem dense onClick={onClickInsightL}>*/}
      {/*    <div className={classes.menuItemBox}>*/}
      {/*      <ImageIcon src={require('src/images/ic_insight.png')} style={{padding: 2}} />*/}
      {/*      <Space verticalSpace={1.2} />*/}
      {/*      <Typography variant={'body2'} color={'textPrimary'}>*/}
      {/*        <FormattedMessage id='activity.insight' />*/}
      {/*      </Typography>*/}
      {/*    </div>*/}
      {/*  </MenuItem>*/}
      {/*  : null*/}
      {/*}*/}
      {item.canProcessWinners ?
        <MenuItem dense onClick={onClickDeclareWinnersL}>
          <div className={classes.menuItemBox}>
            <ImageIcon src={require('src/images/ic_declare_winner.png')} />
            <Space verticalSpace={1.2} />
            <Typography color={'textPrimary'} variant={'body2'}>
              <FormattedMessage id='campaign.declareWinners' />
            </Typography>
          </div>
        </MenuItem>
        : null
      }
      {!isItemReward && !hasNoPlan && !item.isCodeNeeded && !isPlanEnded && item.type !== constants.activity.types.SHOWCASE_MENU ?
        <MenuItem dense onClick={onClickEndCampaignL}>
          <div className={classes.menuItemBox}>
            <ImageIcon src={require('src/images/ic_end_campaign.png')} width={17} />
            <Space verticalSpace={1.2} />
            <Typography color={'textPrimary'} variant={'body2'}>
              <FormattedMessage id='campaign.endCampaign' />
            </Typography>
          </div>
        </MenuItem>
        : null
      }
    </Menu>
  );
});

const Row = ({index, style, data}) => {
  const {items, canLoadMore, rowHSpacing, itemWidth, itemHeight,
    app, classes, isXS, isListC2Up,
    onClickViewCampaign, onClickLink, onClickInsight, onClickPromote, onClickEdit,
    onClickAnswerDistribution, onClickGuessDistribution, onClickActivityReviews, onClickMore} = data;
  if (index > items.length || (index === items.length && !canLoadMore)) {
    return <div style={style}>
        <div style={{width: '100%', height: '100%', display: 'flex', alignItems: 'center', justifyContent: 'center'}}>
      </div>
    </div>
  }
  if (index === items.length) {
    return <div style={style}>
      <div style={{width: '100%', height: '100%', display: 'flex', alignItems: 'center', justifyContent: 'center'}}>
        <CircularProgress size={24} />
      </div>
    </div>
  }
  const item = items[index];
  const isLast = index === items.length - 1;
  return <div style={style} key={item.id +'-'+ item.isNew}>
    <div style={{width: '100%', height: '100%', paddingLeft: rowHSpacing, paddingRight: rowHSpacing, paddingBottom: isXS ? (isLast ? 64 : 16) : (isLast ? 2 : 1)}}>
      <GetViewForItem
        isFirst={index === 0}
        isLast={isLast}
        item={item}
        index={index}
        isLTR={app.isLTR}
        itemWidth={itemWidth}
        itemHeight={itemHeight}
        classes={classes}
        isXS={isXS}
        isListC2Up={isListC2Up}
        onClickViewCampaign={onClickViewCampaign}
        onClickAnswerDistribution={onClickAnswerDistribution}
        onClickGuessDistribution={onClickGuessDistribution}
        onClickActivityReviews={onClickActivityReviews}
        onClickLink={onClickLink}
        onClickInsight={onClickInsight}
        onClickPromote={onClickPromote}
        onClickEdit={onClickEdit}
        onClickMore={onClickMore}
      />
    </div>
  </div>
};

class ActivityLists extends React.Component {

  constructor(props) {
    super(props);
    this.readOnly = !auth.isAuthenticated();

    const searchParams = getURLParameters(decodeURIComponent(this.props.location.search));
    this.forceDisplay = searchParams['f'];

    this.isCacheLoaded = false;
    this.isCacheMissLoaded = false;
    this.state = {
      windowWidth: window.appWidth,
      windowHeight: window.appHeight,
      searchText: '',
      localitySearch: '',
      listScrollOffset: 0,

      showStateChangeModal: false,
      showDeleteModal: false,
      activityData: null,
      isFetchInProgress: true,
      declareWinnersOption: "0",

      filters: {
        types: [],
        states: [],
        localityIds: [],
      },
      selectedFilters: [],
      filterObjs: {
        types: [],
        states: [],
        localityIds: [],
      },
    };

    this.fetchLocalities = debounce(this.fetchLocalities, 400);
  }

  componentDidMount() {
    if (!auth.isAuthenticated() && !this.forceDisplay) {
      this.props.history.replace(PathLanding);
      return;
    }

    document.title = this.isShowingRewards() ? 'Rab7 | My Rewards' : 'Rab7 | My Campaigns';
    changeNavColor(ColorBackground);

    this.pathname = this.props.history.location.pathname;
    this.fetchData(true);
    window.addEventListener('resize', this.onWindowResize);
  }

  componentWillUnmount() {
    window.removeEventListener('resize', this.onWindowResize);
  }

  componentDidUpdate(prevProps) {
    const path = getCompletePath(this.props.history.location, true);
    if (path.startsWith(this.pathname) && this.lastPath !== path) {
      this.fetchData();
    }
  }

  shouldComponentUpdate(nextProps, nextState, nextContext) {
    if (nextProps.activities.cacheMiss && !this.isCacheMissLoaded) {
      this.isCacheMissLoaded = true;
      this.fetchData();
    } else if (nextProps.activities.cache && !this.isCacheLoaded) {
      this.props.resetCacheListData();
      this.isCacheLoaded = true;
      this.setState({isFetchInProgress: false}, () => {
        if (this.refList) {
          this.refList.scrollTo(nextProps.activities.scrollTo);
        }
      });
    }
    return true;
  }

  onAppDidFocus = () => {
    if (this.refVideoLanding) {
      this.refVideoLanding.play();
    }
  };

  onAppDidBlur = () => {
    if (this.refVideoLanding) {
      this.refVideoLanding.pause();
    }
  };

  onWindowResize = (event) => {
    // changeBodyColor(window.appWidth <= 600 ? ColorBackgroundXS : ColorBackground);
    this.setState({windowWidth: window.appWidth, windowHeight: window.appHeight});
  }

  onRetryClicked = () => {
    this.fetchData();
  };

  fetchData(cache = false, skipPush = true) {
    let searchText = null;
    let page = 1;
    let filterStatesText = null;
    let filterTypesText = null;
    let hash = this.props.history.location.hash;
    if (hash && hash.length > 0) {
      hash = hash.replace("#", "");
      const params = hash.split('&');
      if (params && params.length > 0) {
        params.forEach((param) => {
          if (param && param.length > 0) {
            const keyValues = param.split('=');
            if (keyValues && keyValues.length >= 0) {
              const key = keyValues[0];
              const value = keyValues.length >= 1 ? keyValues[1] : null;
              if (value && value.length > 0) {
                if (key === "s") {
                  searchText = value;
                } else if (key === "p") {
                  page = value;
                } else if (key === "fs") {
                  filterStatesText = value;
                } else if (key === "ft") {
                  filterTypesText = value;
                }
              }
            }
          }
        });
      }
    }
    let filters = null;
    let filterObjs = null;
    const newState = {};
    if (searchText || page > 1 || filterStatesText || filterTypesText) {
      if (searchText) {
        newState.searchText = searchText;
      }
      if (filterStatesText || filterTypesText) {
        filters = {
          types: [],
          states: [],
        }
        filterObjs = {
          types: [],
          states: [],
        }
        if (filterStatesText) {
          const filtersData = this.queryParamToFiltersData(filterStatesText, filtersUtil.getActivityStates())
          filters.states = filtersData.ids;
          filterObjs.states = filtersData.objs;
        }
        if (filterTypesText) {
          const filtersData = this.queryParamToFiltersData(filterTypesText, filtersUtil.getActivityTypes())
          filters.types = filtersData.ids;
          filterObjs.types = filtersData.objs;
        }
        newState.filters = filters;
        newState.filterObjs = filterObjs;
      }
      this.setState(newState);
    }

    this.fetchActivities(searchText, page, null, filters, cache, skipPush);
  }

  queryParamToFiltersData(filterIdsText, filters, isNumeric = true) {
    const filterIds = [];
    const filterObjs = [];
    if (filterIdsText && filterIdsText.length > 0) {
      const lFilterIds = filterIdsText.split(',');
      if (lFilterIds && lFilterIds.length >= 0) {
        lFilterIds.forEach((filterId) => {
          if (filterId && filterId.length > 0) {
            if (filters) {
              filters.forEach((filter) => {
                if (isNumeric) {
                  filterId = parseInt(filterId);
                }
                if (filter.value === filterId) {
                  filterIds.push(filterId);
                  filterObjs.push(filter);
                }
              });
            }
          }
        });
      }
    }
    return {
      'ids': filterIds,
      'objs': filterObjs
    };
  }

  filterToQueryParam(filterIds, filterKey) {
    if (filterIds && filterIds.length > 0) {
      return filterKey +'=' + implode(',', filterIds);
    }
    return null;
  }

  isShowingRewards() {
    const {history} = this.props;
    const path = get(history, 'location.pathname');
    return path.startsWith('/rewards');
  }

  getCampaignUsageType() {
    const {history} = this.props;
    const path = get(history, 'location.pathname');
    if (path.startsWith('/marketingCampaigns')) {
      return constants.activity.usageTypes.MARKETING;
    }
    if (path.startsWith('/loyaltyCampaigns')) {
      return constants.activity.usageTypes.LOYALTY;
    }
    if (path.startsWith('/educationCampaigns')) {
      return constants.activity.usageTypes.EDUCATION;
    }
    if (path.startsWith('/trainingCampaigns')) {
      return constants.activity.usageTypes.TRAINING;
    }
    if (path.startsWith('/socialCampaigns')) {
      return constants.activity.usageTypes.SOCIAL;
    }
    if (path.startsWith('/influencerCampaigns')) {
      return constants.activity.usageTypes.INFLUENCER;
    }
    return 0;
  }

  getNoItemsView() {
    const {classes, isXS, isDrawerHidden} = this.props;
    const campaignUsageType = this.getCampaignUsageType();
    let columns = 3;
    if (isXS) {
      columns = 1;
    } else if (isDrawerHidden) {
      columns = 2;
    }
    if (campaignUsageType === 0) {
      return (
        <div className={classes.flexColumn} style={{padding: isXS ? 8 : 16}}>
          <Space horizontalSpace={1} />
          <Typography variant={isXS ? "subtitle2" : "subtitle1"} color={'textSecondary'} align={'center'} className={classes.typoMedium}>
            {<FormattedMessage id={'home.gettingStartedM'} />}
          </Typography>
          <Space horizontalSpace={2} />
          <GridList cols={columns} className={classes.usageCardWrapper} cellHeight={'auto'}>
            {ACTIVITY_USAGE_TYPES_MODEL.map((item, index) => {
              return (
                <div style={{padding: isXS ? 6 : 8}}>
                  <div
                    className={classes.usageCardButtonBase} style={{height: '100%'}}>
                    <div className={isXS ? classes.flexRowNoCenter : classes.flexColumnNoCenter}>
                      <img className={classes.usageCardImage} src={item.image}/>
                      <Space verticalSpace={isXS ? 1.5 : 0} horizontal={isXS ? 0 : 6}/>
                      <div className={classes.viewRowFullWidth} style={{alignItems: 'flex-end'}}>
                        <div className={classes.flexColumnNoCenter}>
                          <Typography align={'left'} variant={isXS ? "subtitle2" : "subtitle1"} color="textPrimary" className={classes.typoMedium}>
                            {item.name}
                          </Typography>
                          <Space horizontal={isXS ? 1 : 2}/>
                          <Typography align={'left'} variant={isXS ? "caption" : "body2"} color="textSecondary">
                            {item.details}
                          </Typography>
                        </div>
                        <Space verticalSpace={1}/>
                        <Button
                          disableElevation={true}
                          size={'small'}
                          color={'primary'}
                          variant={'contained'}
                          onClick={this.onClickAddNew.bind(this, item.id)}
                          style={{marginBottom: 4}}>
                          <FormattedMessage id={'activity.start'} />
                        </Button>
                      </div>
                    </div>
                  </div>
                </div>
              );
            })}
          </GridList>
        </div>
      );
    } else {
      let usageTypeObj = null;
      ACTIVITY_USAGE_TYPES_MODEL.forEach((usage) => {
        if (usage.id === campaignUsageType) {
          usageTypeObj = usage;
        }
      });
      return (
        <div className={classes.flexColumn} style={{padding: 16, minHeight: 400, maxWidth: 1200, justifyContent: 'center'}}>
          <img width={100} height={100} src={usageTypeObj.image} style={{borderRadius: BORDER_RADIUS, border: `1px solid rgba(0,0,0,0.05)`}} />
          <Space horizontalSpace={2} />
          <Typography variant="h6" color={'textSecondary'} align={'center'} className={classes.typoNormal}>
            {<FormattedMessage id={usageTypeObj.details} />}
          </Typography>
          <Space horizontalSpace={6} />
          <Button
            variant="contained"
            size={"large"}
            color="primary"
            className={classes.buttonAdd}
            onClick={this.onClickAddNew.bind(this, undefined)}
            startIcon={<AddIcon fontSize={'large'} />}>
            <FormattedMessage id={usageTypeObj.addButtonId} />
          </Button>
        </div>
      );
    }
  }

  getNoItemsView1() {
    const {app, classes, isXS} = this.props;
    const isLTR = app.isLTR;
    return (
      <div className={classes.flexColumn} style={{padding: 16, paddingTop: isXS ? 0 : 16, minHeight: Math.min(window.appHeight - TOOLBAR_HEIGHT, 920), maxWidth: isXS ? 500 : 600}}>
        <img src={require('src/images/logo.png')} style={{width: 160, height: 160}} />
        <FieldSpace multiplier={1} />
        <TextView align={'center'} variant={'h4'} text={'RAB7.COM'} color={ColorTitle} fontWeight={FONT_WEIGHT_BOLD} />
        <FieldSpace multiplier={1} />
        <TextView align={'center'} variant={'h6'} textId={'app.slogan'} color={ColorSubTitle} fontWeight={FONT_WEIGHT_MEDIUM} />
        <FieldSpace multiplier={2} />
        {/*{isXS ? <div className={classes.flex1}/> : <div style={{minHeight: 100}}/>}*/}
        <div className={classes.flex1}/>
        <div className={classes.viewColumn}>
          <Button
            fullWidth={true}
            onClick={this.onAboutUsClicked}
            disableElevation={true}
            variant={'outlined'}
            color={'primary'}
            style={{minHeight: 60, minWidth: 150, borderWidth: 4, borderColor: ColorTitle, padding: 16}}>
            <div className={classes.viewRowFullWidth}>
              <ImageIcon src={require('src/images/img_about.png')} width={34} height={34} style={{marginLeft: !isLTR ? 16 : 0, marginRight: isLTR ? 16 : 0}} />
              <TextView align={'left'} variant={'h5'} fontWeight={FONT_WEIGHT_BOLD} color={ColorTitle} style={{width: '100%'}}><FormattedMessage id={'menu.whatIsRab7'}/></TextView>
            </div>
          </Button>
          <FieldSpace />
          <Button
            fullWidth={true}
            onClick={this.onHowItWorksClicked}
            disableElevation={true}
            variant={'outlined'}
            color={'primary'}
            size={'large'}
            style={{minHeight: 60, minWidth: 150, borderWidth: 4, borderColor: ColorTitle, padding: 16}}>
            <div className={classes.viewRowFullWidth}>
              <ImageIcon src={require('src/images/img_how_works.png')} width={32} height={32} style={{marginLeft: !isLTR ? 16 : 0, marginRight: isLTR ? 16 : 0}} />
              <div className={classes.flex1}/>
              <TextView align={'left'} variant={'h5'} fontWeight={FONT_WEIGHT_BOLD} color={ColorTitle} style={{width: '100%'}}><FormattedMessage id={'menu.howRab7Works'}/></TextView>
            </div>
          </Button>
        </div>
        <FieldSpace multiplier={2}/>
        {/*{isXS ? <div style={{flex: 0.5}}/> : <div style={{minHeight: 60}}/>}*/}
        <div style={{flex: 0.5}}/>
        {/*{this.readOnly || !this.props.user || !this.props.user.registerType ?*/}
        {/*  <React.Fragment>*/}
        {/*    <Button*/}
        {/*      fullWidth={true}*/}
        {/*      onClick={this.onJoinUsClicked}*/}
        {/*      disableElevation={true}*/}
        {/*      variant={'contained'}*/}
        {/*      color={'primary'}*/}
        {/*      size={'large'}*/}
        {/*      style={{minHeight: 60, minWidth: 150, padding: 16}}>*/}
        {/*      <TextView variant={'h5'} fontWeight={FONT_WEIGHT_BOLD} color={ColorWhite}><FormattedMessage id={'login.joinRab7Short'}/></TextView>*/}
        {/*    </Button>*/}
        {/*    <FieldSpace multiplier={1} />*/}
        {/*  </React.Fragment>*/}
        {/*  : null*/}
        {/*}*/}
        <Button
          fullWidth={true}
          onClick={this.onClickAddNew.bind(this, undefined)}
          disableElevation={true}
          variant={'contained'}
          color={'primary'}
          size={'large'}
          style={{minHeight: 60, minWidth: 150, padding: 16}}>
          <TextView variant={'h5'} fontWeight={FONT_WEIGHT_BOLD} color={ColorWhite}><FormattedMessage id={'generic.startFreeNow'}/></TextView>
        </Button>
        <FieldSpace multiplier={1} />
      </div>
    );
  }

  getNoItemsVideoView() {
    const {app, classes, isDrawerHidden, isXS} = this.props;
    let maxWidth = window.appWidth - (!isDrawerHidden ? DRAWER_WIDTH : 0);
    let maxHeight = window.appHeight - (isXS ? TOOLBAR_HEIGHT_XS : TOOLBAR_HEIGHT) - 84 - (isXS ? 12 : 16);
    const aspectRatio = 1.5;
    let width = maxWidth;
    let height = width*aspectRatio;
    if (height > maxHeight) {
      height = maxHeight;
      width = height/aspectRatio;
    }

    const videoJsOptions = {
      width: width,
      height: height,
      objectFit: 'contain',
      alignItems: 'center',
      justifyContent: 'center',
      borderRadius: RadiusView,
      style: {
        width: width,
        height: height,
        objectFit: 'contain',
        alignItems: 'center',
        justifyContent: 'center',
        borderRadius: RadiusView
      },
      autoplay: true,
      controls: false,
      muted: true,
      loop: true,
      playsinline: true,
      disablePictureInPicture: true,
      // poster: videoPosterUrl,
      // children: {loadingSpinner: false},
      controlBar: {
        pictureInPictureToggle: false
      },
      sources: [
        {src: app.isLTR ? (this.readOnly ? require('src/images/landing_en.mp4') : require('src/images/landing_a_en.mp4')) : (this.readOnly ? require('src/images/landing_ar.mp4') : require('src/images/landing_a_ar.mp4')), type: 'video/mp4'},
      ],
      eListenerOnProgress: (progress) => {
      },
      eListenerOnError: () => {
        this.setState({landingVideoError: true})
      },
      eListenerOnEnded: () => {
      },
      eListenerOnMuted: () => {
      },
    };
    return (
      <div className={classes.flexColumn}>
        {!this.state.landingVideoError ?
          <React.Fragment>
            <FocusHelperView
              onAppDidFocus={this.onAppDidFocus}
              onAppDidBlur={this.onAppDidBlur}
            />
            <VideoPlayer ref={(ref) => this.refVideoLanding = ref} {...videoJsOptions} />
          </React.Fragment>
          : <div className={classes.viewColumnFullWidth} style={{padding: 16}}>
            <TextView variant={'h6'} color={ColorSecondary} fontWeight={FONT_WEIGHT_MEDIUM} align={'center'}><FormattedHTMLMessage id={'activity.landingTitle'}/></TextView>
            <TextView color={ColorSecondary} fontWeight={FONT_WEIGHT_MEDIUM} align={'center'}><FormattedHTMLMessage id={'activity.landingSubTitle'}/></TextView>
          </div>
        }
        <div className={classes.viewRow}>
          {/*{this.readOnly ?*/}
          {/*  <Button*/}
          {/*    onClick={this.onAboutUsClicked}*/}
          {/*    disableElevation={true}*/}
          {/*    variant={'outlined'}*/}
          {/*    color={'primary'}*/}
          {/*    style={{margin: 12, marginRight: 0}}>*/}
          {/*    <FormattedMessage id='menu.aboutUs'/>*/}
          {/*  </Button>*/}
          {/*  : null*/}
          {/*}*/}
          <Button
            onClick={this.readOnly ? this.onJoinUsClicked : this.onClickAddNew.bind(this, undefined)}
            disableElevation={true}
            variant={'contained'}
            color={'primary'}
            size={'large'}
            style={{margin: 12, minHeight: 60, minWidth: 150}}>
            <TextView variant={'h6'} fontWeight={FONT_WEIGHT_MEDIUM} color={ColorWhite}><FormattedMessage id={'activity.startNow'}/></TextView>
          </Button>
        </div>
      </div>
    );
  }

  getNoItemsMessageId() {
    if (this.isShowingRewards()) {
      return 'list.noRewardsFound';
    }
    return 'list.noCampaignsFound';
  }

  getNoMoreItemsMessage() {
    if (this.isShowingRewards()) {
      return 'list.noMoreRewardsFound';
    }
    return 'list.noMoreCampaignsFound';
  }

  render() {
    const {app, classes, isLoading, activities, isDrawerHidden, isXS, isListC2Up} = this.props;
    const {isFetchInProgress, windowWidth, windowHeight, listScrollOffset, searchText, filterObjs} = this.state;

    // if (isLoading) {
    //   return null;
    // }
    // if (activities.isFetchInProgress && activities.paginated.data.length === 0) {
    //   return <div className={classes.viewLoading} style={{left: app.isLTR && !isDrawerHidden ? DRAWER_WIDTH : 0, right: app.isLTR && !isDrawerHidden ? 0 : DRAWER_WIDTH}}>
    //     <CircularProgress />
    //   </div>;
    // }

    const showMessage = (!isFetchInProgress || activities.errMsgF) && activities.paginated.data.length === 0 && activities.paginated.totalSize === 0;
    const showHeader = !isXS && (activities.paginated.data.length > 0 || activities.paginated.totalSize > 0);
    let noItemsMessageView = null;
    let messageId = null;
    let showRetry = false;
    let retryOnClick = this.onRetryClicked;
    let retryTitleId = 'retry';
    if (activities.paginated.data.length === 0) {
      if (activities.errMsgF) {
        messageId = activities.errMsgF;
        showRetry = true;
      } else if (!isLoading) {
        if (activities.paginated.totalSize > 0) {
          messageId = this.getNoMoreItemsMessage();
        } else {
          if (this.isShowingRewards()) {
            messageId = this.getNoItemsMessageId();
            retryOnClick = this.onAddNewCampaign;
            retryTitleId = 'generic.addCampaign';
            showRetry = true;
          } else {
            messageId = 'activity.noCampaigns';
          }
        }
      }
    }

    const hasOnlyDemoCampaign = activities.paginated.data && activities.paginated.data.length === 1 && activities.paginated.data[0].demo;
    const hideAddButton = this.isShowingRewards() || isDrawerHidden;
    const hideBottomAddButton = this.isShowingRewards() || !isDrawerHidden;
    const tabHeight = isXS ? TOOLBAR_HEIGHT_XS : TOOLBAR_HEIGHT;
    const bottomTabHeight = IS_BOTTOM_TAB_PRESENT && PathHelper.isBottomTabPresent(isDrawerHidden, history) ? (isXS ? BOTTOM_BAR_HEIGHT_XS : BOTTOM_BAR_HEIGHT) : 0;

    const itemsCount = activities.paginated.canLoadMore ? activities.paginated.data.length + 1 : activities.paginated.data.length;

    const gridWidth = windowWidth - (isDrawerHidden ? 0 : DRAWER_WIDTH);
    const gridHeight = windowHeight - tabHeight - bottomTabHeight - (showHeader ? 58 : 9) - (!hideAddButton ? 102 : 0) - (isXS ? 4 : 4);
    const rowHeight = isXS ?  232 : 64;
    const rowWidth = Math.min(gridWidth - (isDrawerHidden ? 32 : 48), CONTENT_MAX_WIDTH - 48);
    const rowHSpacing = Math.floor((gridWidth - rowWidth)/2);

    return (
      <div className={classes.viewColumnFullWidth} style={{marginTop: isXS ? 12 : 16}}>
        <HeaderTitleView isLTR={app.isLTR} isDrawerHidden={isDrawerHidden} isXS={isXS} titleId={this.getHeaderTitleId()}/>
        <AppInstall isLTR={app.isLTR} />
        <LanguageDialog />

        {isFetchInProgress ?
          <div className={classes.viewLoading} style={{left: !isDrawerHidden ? app.isLTR ? DRAWER_WIDTH : 0 : 0, right: !isDrawerHidden ? app.isLTR ? 0 : DRAWER_WIDTH : 0}}>
            <CircularProgress />
          </div>
          : null
        }
        {!isFetchInProgress ?
          <div className={classes.flexColumn} style={{overflow: 'hidden'}}>
            <div className={isXS ? classes.gridItemsWrapperXS : classes.gridItemsWrapper}>
              {noItemsMessageView == null && !hideAddButton ?
                <div className={classes.flexRow} style={{maxWidth: rowWidth}}>
                  {!isXS ? <div className={classes.flex1} /> : null}
                  <Button
                    fullWidth={isXS}
                    disableElevation={true}
                    variant="contained"
                    color="primary"
                    disabled={this.isShowingRewards()}
                    className={classes.buttonAdd}
                    onClick={this.onClickAddNew.bind(this, undefined)}
                    style={{opacity: this.isShowingRewards() ? 0 : 1, marginTop: 0, marginBottom: 12, height: isXS ? 48 : 90}}>
                    <div className={isXS ? classes.viewRow : classes.viewColumn} style={{alignItems: 'center'}}>
                      {!isXS ? <AppIcon icon={IconAdd} color={ColorWhite} size={isXS ? 'lg' : 'xl'} /> : null}
                      {!isXS ? <Space horizontalSpace={1} verticalSpace={1}/> : null}
                      <FormattedMessage id={this.isShowingRewards() ? 'generic.addOffer' : 'generic.addCampaign'} />
                    </div>
                  </Button>
                </div>
                : null
              }

              {messageId == null && noItemsMessageView == null ?
                <div className={classes.viewColumnFullWidth} style={{overflow: 'hidden'}}>
                  {showHeader ?
                    <div style={{overflow: 'hidden', maxWidth: rowWidth, width: rowWidth}}>
                      {this.getViewTitles(rowWidth)}
                    </div>
                    : null
                  }
                  <div style={{height: listScrollOffset > 0 ? 1 : 0, width: '100%', backgroundColor: 'rgba(0,0,0,0.1)'}} />
                  <InfiniteLoader
                    itemCount={itemsCount}
                    threshold={Math.ceil(activities.paginated.perPage*.2)}
                    isItemLoaded={index => index < activities.paginated.data.length}
                    loadMoreItems={() => {
                      return new Promise(resolve => {
                          const {searchText, filters} = this.state;
                          this.fetchActivities(searchText, activities.paginated.page + 1, null, filters, false, true, () => {
                            resolve();
                          });
                        }
                      );
                    }}>
                    {({onItemsRendered, ref}) => (
                      <VariableSizeList
                        ref={(refL) => {
                          this.refList = refL;
                          ref(refL);
                        }}
                        key={''+ isXS}
                        onItemsRendered={onItemsRendered}
                        onScroll={this.onListScroll}
                        width={gridWidth}
                        height={gridHeight}
                        itemCount={itemsCount}
                        itemSize={(index) => {
                          if (isXS) {
                            if (index < activities.paginated.data.length) {
                              const item = activities.paginated.data[index];
                              const isItemReward = item.type === constants.activity.types.OFFER
                                || item.type === constants.activity.types.DISCOUNT
                                || item.type === constants.activity.types.VOUCHER;
                              // const hasNoPlan = !item.ad || item.ad.planType <= constants.activity.plans.NO_PLAN;
                              let height = 234;
                              // if (!isItemReward && !hasNoPlan) { // extra three in row buttons
                              if (!isItemReward) { // extra three in row buttons
                                height += 44;
                              }
                              if (index === activities.paginated.data.length - 1) { // extra space for add new fab
                                height += 54;
                              }
                              return height;
                            }
                            return 234;
                          }
                          return 64;
                        }}
                        itemData={{
                          items: activities.paginated.data,
                          canLoadMore: activities.paginated.canLoadMore,
                          rowHSpacing: rowHSpacing,
                          itemWidth: rowWidth,
                          app,
                          classes,
                          isXS,
                          isListC2Up,
                          onClickViewCampaign: this.onClickViewCampaign,
                          onClickAnswerDistribution: this.onClickAnswerDistribution,
                          onClickGuessDistribution: this.onClickGuessDistribution,
                          onClickActivityReviews: this.onClickActivityReviews,
                          onClickLink: this.onClickLink,
                          onClickInsight: this.onClickInsight,
                          onClickPromote: this.onClickPromote,
                          onClickEdit: this.onClickEdit,
                          onClickMore: this.onClickMore
                        }}>
                        {Row}
                      </VariableSizeList>
                    )}
                  </InfiniteLoader>

                  {hasOnlyDemoCampaign ?
                    <div style={{position: 'absolute', top: isXS ? 400 : 300, left: 20, right: 20}}>
                      <Typography align={'center'} variant={"h6"} color={'textSecondary'} className={classes.typoMedium}>
                        {<FormattedHTMLMessage id={'activity.noCampaignsDemoOnly'} />}
                      </Typography>
                    </div>
                    : null
                  }
                </div>
                : null
              }
              {noItemsMessageView == null && !hideBottomAddButton ?
                <div style={{position: 'fixed', bottom: 0, top: 'auto', left: 0, right: 0, pointerEvents: 'none', display: 'flex', flexDirection: 'row', justifyContent: 'center'}}>
                  <Fab
                    onClick={this.onClickAddNew.bind(this, undefined)}
                    color={"primary"}
                    size={'large'}
                    style={{marginBottom: 12, pointerEvents: 'auto', width: 64, height: 64}} >
                    <AppIcon icon={IconAdd} color={ColorWhite} style={{width: 24, height: 24}} />
                  </Fab>
                  {/*<Button*/}
                  {/*  fullWidth={isXS}*/}
                  {/*  disableElevation={true}*/}
                  {/*  variant="contained"*/}
                  {/*  color="primary"*/}
                  {/*  disabled={this.isShowingRewards()}*/}
                  {/*  className={classes.buttonAdd}*/}
                  {/*  onClick={this.onClickAddNew.bind(this, undefined)}*/}
                  {/*  style={{opacity: this.isShowingRewards() ? 0 : 1, marginTop: 0, marginBottom: 12, height: isXS ? 48 : 90}}>*/}
                  {/*  <div className={isXS ? classes.viewRow : classes.viewColumn} style={{alignItems: 'center'}}>*/}
                  {/*    {!isXS ? <AppIcon icon={IconAdd} color={ColorWhite} size={isXS ? 'lg' : 'xl'} /> : null}*/}
                  {/*    {!isXS ? <Space horizontalSpace={1} verticalSpace={1}/> : null}*/}
                  {/*    <FormattedMessage id={this.isShowingRewards() ? 'generic.addOffer' : 'generic.addCampaign'} />*/}
                  {/*  </div>*/}
                  {/*</Button>*/}
                </div>
                : null
              }
            </div>

            {noItemsMessageView}

            {messageId != null && (
              <div className={classes.containerError}>
                <Typography align={'center'} variant={"h6"} color={'textSecondary'} className={classes.typoMedium}>
                  {<FormattedMessage id={messageId} />}
                </Typography>
                {showRetry ?
                  <Button
                    disableElevation={true}
                    style={{marginTop: FIELD_SPACE}}
                    size={isXS ? 'small' : 'medium'}
                    variant={'contained'}
                    color={"primary"}
                    onClick={retryOnClick}>
                    {<FormattedMessage id={retryTitleId} />}
                  </Button>
                  : null
                }
              </div>
            )}

            {this.renderDeleteConfirmModal()}
            {this.renderStateChangeConfirmModal()}
            {this.renderSnackBarReducer()}
            {this.renderSnackBar()}
            {this.renderDialogView()}
            {this.renderResendVerificationView()}
            {this.renderMenu()}
          </div>
          : null
        }
      </div>
    );
  }

  renderMenu() {
    const {classes, isXS} = this.props;
    const showMenu = this.state.showMenuItem != null;
    if (!showMenu) {
      return null;
    }
    return (
      <MenuView
        item={this.state.showMenuItem}
        index={this.state.showMenuIndex}
        classes={classes}
        isXS={isXS}
        showMenu={showMenu}
        showMenuElement={showMenu ? this.state.showMenuElement : null}
        onClickPromote={this.onClickPromote}
        onClickEdit={this.onClickEdit}
        onCloseMore={this.onCloseMore}
        onClickToggleItem={this.onClickToggleItem}
        onClickDeleteItem={this.onClickDeleteItem}
        onClickInsight={this.onClickInsight}
        onClickAnswerDistribution={this.onClickAnswerDistribution}
        onClickGuessDistribution={this.onClickGuessDistribution}
        onClickShowWinners={this.onClickShowWinners}
        onClickActivityReviews={this.onClickActivityReviews}
        onClickViewPlan={this.onClickViewPlan}
        onClickViewCampaign={this.onClickViewCampaign}
        onClickLink={this.onClickLink}
        onClickDeclareWinners={this.onClickDeclareWinners}
        onClickEndCampaign={this.onClickEndCampaign}/>
    );
  }

  renderDialogView() {
    const {classes} = this.props;
    const {showDialog, dialogInfo} = this.state;
    if (!showDialog) {
      return null;
    }

    return (
      <DialogView
        classes={classes}
        show={showDialog}
        {...dialogInfo}
      />
    );
  }

  showDialog(dialogInfo) {
    if (dialogInfo) {
      this.setState({showDialog: true, dialogInfo: dialogInfo});
    }
  }

  hideDialog = (stateFields, onStateUpdated) => {
    let hideDialogFields = {showDialog: false, dialogInfo: null};
    if (stateFields) {
      hideDialogFields = Object.assign(hideDialogFields, stateFields);
    }
    this.setState(hideDialogFields, onStateUpdated);
  }

  reloadView = () => {
    this.setState({reload: !this.state.reload})
  }

  showAccountActivationPendingDialog() {
    this.showDialog({
      title: this.context.intl.formatMessage({id: 'login.accountActivationPending'}),
      message: this.context.intl.formatMessage({id: 'login.accountActivationPendingMessage'}),
      positiveText: this.context.intl.formatMessage({id: 'login.resendVerificationLink'}),
      onPositiveClicked: this.showResendVerification,
      neutralText: this.context.intl.formatMessage({id: 'generic.later'}),
      onNeutralClicked: this.hideDialog,
    });
  }

  renderResendVerificationView() {
    if (!this.state.showResendVerification) {
      return null;
    }
    return <InitiateVerifyAccount onDone={this.hideResendVerification} />;
  }

  showResendVerification = () => {
    this.setState({showDialog: false, dialogInfo: null, showResendVerification : true});
  };

  hideResendVerification = () => {
    this.setState({showResendVerification : false});
  };

  onListScroll = ({scrollDirection, scrollOffset, scrollUpdateWasRequested}) => {
    const {listScrollOffset} = this.state;
    if (!listScrollOffset && scrollOffset || listScrollOffset && !scrollOffset) {
      this.setState({listScrollOffset: scrollOffset});
    } else {
      this.state.listScrollOffset = scrollOffset;
    }
  };

  getViewTitles(itemWidth) {
    const {classes, app, isXS, isListC1Down} = this.props;
    const isListC2Up = itemWidth > 1000;
    const alignFlexColumn = ALIGN_DIR === 'left' ? classes.flexColumnNoCenter : classes.flexColumn;

    let actionsTitleId = null;
    if (this.isShowingRewards()) {
      actionsTitleId = 'campaign.consumes';
    } else {
      // actionsTitleId = 'campaign.plays';
      actionsTitleId = 'campaign.actions';
    }
    const align = isXS ? ALIGN_DIR : 'center';
    const imageWidth = !isListC2Up ? 52 : 56;
    return (
      <Paper elevation={0} key={'-1'} className={classes.cardItemWrapper} style={{backgroundColor: ColorClear, marginBottom: 4, marginTop: 8}}>
        <div className={classes.cardItem}>
          <div className={isXS ? classes.cardItemContentXS : (this.isShowingRewards() ? classes.cardItemContentOffers : classes.cardItemContent)} style={{minHeight: 30}}>
            <div className={classes.cardItemContentPart1} style={{flex: .9}}>
              <div className={classes.flexRow} style={{flex: 1}}>
                <div className={isListC2Up ? classes.flexRow : classes.flexColumnNoCenter} style={{flex: 1, paddingLeft: app.isLTR ? imageWidth+8 : 0, paddingRight: !app.isLTR ? imageWidth+8 : 0}}>
                  <div className={classes.viewColumn} style={{flex: isListC2Up ? .8 : 1}}>
                    <Typography variant="body2" color='textSecondary'>
                      {<FormattedMessage id={'activity.manage.title'} />}
                    </Typography>
                  </div>
                  {isListC2Up ? <Space verticalSpace={1} /> : null}
                  {isListC2Up ?
                    <div className={classes.viewColumn} style={{flex: isListC2Up ? .3 : 1, minWidth: 90}}>
                      <Typography variant="body2" align={isListC2Up ? align : 'left'} color='textSecondary'>
                        {<FormattedMessage id={'activity.manage.type'} />}
                      </Typography>
                    </div>
                    : null
                  }
                </div>
              </div>
            </div>
            <Space verticalSpace={1} />

            <div className={classes.cardItemContentPart2} style={{flex: 1.1, minWidth: 400}}>
              <div className={classes.viewRow} style={{flex: .4, minWidth: 188}}>
                <div className={alignFlexColumn} style={{flex: .5, minWidth: 90}}>
                  <Typography variant="body2" color='textSecondary' align={align}>
                    {<FormattedMessage id={'campaign.start'} />}
                  </Typography>
                </div>
                {!isXS ?
                  <Space verticalSpace={1} />
                  : null
                }
                {!isXS ?
                  <div className={alignFlexColumn} style={{flex: .5, minWidth: 90}}>
                    <Typography variant="body2" color='textSecondary' align={align}>
                      {<FormattedMessage id={'campaign.end'} />}
                    </Typography>
                  </div>
                  : null
                }
              </div>
              <Space verticalSpace={1} />

              <div className={alignFlexColumn} style={{flex: this.isShowingRewards() ? .19 : .2, minWidth: 62}}>
                <Typography variant="body2" color='textSecondary' align={align}>
                  {<FormattedMessage id={'campaign.views'} />}
                </Typography>
              </div>
              <Space verticalSpace={1} />

              <div className={alignFlexColumn} style={{flex: this.isShowingRewards() ? .21 : .2, minWidth: 62}}>
                <Typography variant="body2" color='textSecondary' align={align}>
                  {<FormattedMessage id={actionsTitleId} />}
                </Typography>
              </div>
              <Space verticalSpace={1} />

              <div className={alignFlexColumn} style={{flex: .2, minWidth: 62}}>
                <Typography variant="body2" color='textSecondary' align={align}>
                  {<FormattedMessage id={'campaign.status'} />}
                </Typography>
              </div>
            </div>

            <div className={isXS ? classes.cardItemActionWrapperV : (this.isShowingRewards() ? classes.cardItemActionWrapperOffers : classes.cardItemActionWrapper)} style={{backgroundColor: ColorClear}}>
              <Typography variant="body2" style={{minWidth: this.isShowingRewards() ? ACTIONS_OFFER_VIEW_WIDTH : ACTIONS_VIEW_WIDTH}} align={ALIGN_DIR} color={'textSecondary'}>
                {''}
                {/*{isXS ? '' : <FormattedMessage id={'campaign.actions'} />}*/}
              </Typography>
            </div>
          </div>
        </div>
      </Paper>
    );
  }

  renderDeleteConfirmModal() {
    const {showDeleteModal, activityData, activityIndex} = this.state;
    const {classes, deleteActivity, activities} = this.props;
    const _this = this;

    if (!showDeleteModal) {
      return null;
    }

    return (
      <Dialog disableBackdropClick onClose={this.onDialogClose} aria-labelledby="customized-dialog-title" open={showDeleteModal}>
        <DialogTitle>
          {/*<IconButton color={"primary"} className={classes.dialogCloseButton} onClick={this.onDialogClose}>*/}
          {/*  <CloseIcon />*/}
          {/*</IconButton>*/}
          <TextView numberOfLines={3} variant="h6" align="center" style={{color: ColorTitle}}>
            <FormattedMessage id={this.isItemReward(activityData) ? 'campaign.deleteRewardWithId' : 'campaign.deleteCampaignWithId'} values={{value: activityData.title}} />
          </TextView>
        </DialogTitle>
        <DialogContent>
          <div style={{display: 'flex', flexDirection: 'column', alignItems: 'center'}}>
            <Typography align="center" style={{color: ColorSubTitle}}>
              <FormattedMessage id={this.isItemReward(activityData) ? 'campaign.deleteRewardMsg' : 'campaign.deleteCampaignMsg'} />
            </Typography>
            <Space bottom={24}/>
          </div>
        </DialogContent>
        <DialogActions>
          <div className={classes.dialogActionsViewOutline}>
            <Button
              disableElevation
              variant={"outlined"}
              color="secondary"
              onClick={() => {
                _this.setState({
                  showDeleteModal: false,
                  activityData: null
                });
              }}>
              <FormattedMessage id={'generic.cancel'} />
            </Button>
            <Space verticalSpace={2} />
            <Button
              disableElevation
              variant={"contained"}
              color="primary"
              onClick={() => {
                _this.setState({
                  showDeleteModal: false,
                  activityData: null
                });
                deleteActivity(activityData.id, activityData.type).then(() => {
                  if (_this.refList && activityIndex > 0) {
                    _this.refList.resetAfterIndex(activityIndex - 1);
                  }
                });
              }}>
              <FormattedMessage id={'action.delete'} />
            </Button>
          </div>
        </DialogActions>
      </Dialog>
    );
  }

  renderStateChangeConfirmModal() {
    const {showStateChangeModal, activityData} = this.state;
    const {classes, toggleActivityState} = this.props;
    const _this = this;

    if (!showStateChangeModal) {
      return null;
    }
    let titleId = null;
    if (this.isItemReward(activityData)) {
      titleId = activityData.state === constants.activity.state.ACTIVE ? 'campaign.deactivateRewardWithId' : 'campaign.activateRewardWithId'
    } else {
      titleId = activityData.state === constants.activity.state.ACTIVE ? 'campaign.deactivateCampaignWithId' : 'campaign.activateCampaignWithId'
    }

    return (
      <Dialog disableBackdropClick onClose={this.onDialogClose} aria-labelledby="customized-dialog-title" open={showStateChangeModal}>
        <DialogTitle>
          {/*<IconButton color={"primary"} className={classes.dialogCloseButton} onClick={this.onDialogClose}>*/}
          {/*  <CloseIcon />*/}
          {/*</IconButton>*/}
          <Typography variant="h6" align="center" style={{color: ColorTitle}}>
            <FormattedMessage id={titleId} values={{value: activityData.title}} />
          </Typography>
        </DialogTitle>
        {/*<DialogContent>*/}
        {/*  <div style={{display: 'flex', flexDirection: 'column', alignItems: 'center'}}>*/}
        {/*    <Typography align="center">*/}
        {/*      <FormattedMessage id={activityData.state === constants.activity.state.ACTIVE ? 'admin.activity.deactivateCampaignMsg' : 'admin.activity.activateCampaignMsg'} />*/}
        {/*    </Typography>*/}
        {/*    <Space bottom={24}/>*/}
        {/*  </div>*/}
        {/*</DialogContent>*/}
        <DialogActions>
          <div className={classes.dialogActionsViewOutline}>
            <Button
              variant={"outlined"}
              color="secondary"
              onClick={() => {
                _this.setState({
                  showStateChangeModal: false,
                  activityData: null
                });
              }}>
              <FormattedMessage id={'generic.cancel'} />
            </Button>
            <Space verticalSpace={2} />
            <Button
              disableElevation
              variant={"contained"}
              color="primary"
              onClick={() => {
                _this.setState({
                  showStateChangeModal: false,
                  activityData: null
                });

                const newState = (activityData.state === constants.activity.state.INACTIVE) ? constants.activity.state.ACTIVE : constants.activity.state.INACTIVE;
                toggleActivityState(activityData.id, newState, activityData.type)
              }}>
              <FormattedMessage id={activityData.state === constants.activity.state.ACTIVE ? 'action.deactivate' : 'action.activate'} />
            </Button>
          </div>
        </DialogActions>
      </Dialog>
    );
  }

  handleAlertClose = () => {
    this.props.resetActivitiesError();
  };

  renderSnackBarReducer() {
    const {activities} = this.props;
    const showErrorSnack = activities.errMsg && (!(typeof activities.errMsg === 'string' || activities.errMsg instanceof String) || activities.errMsg.length > 0);
    const showSuccessSnack = activities.successMsg && (!(typeof activities.successMsg === 'string' || activities.successMsg instanceof String) || activities.successMsg.length > 0);
    const showSnack = showErrorSnack || showSuccessSnack;
    const severity = showErrorSnack ? "error" : "success";
    const message = showErrorSnack ? activities.errMsg : activities.successMsg;
    return (
      <Snackbar open={showSnack} autoHideDuration={SNACKBAR_AUTO_HIDE_DURATION} onClose={this.handleAlertClose}>
        <MuiAlert severity={severity} onClose={this.handleAlertClose} elevation={6} variant="filled">
          {message}
        </MuiAlert>
      </Snackbar>
    );
  }

  renderSnackBar() {
    const {snackbarMessageId, snackbarType} = this.state;
    const onClose = () => {
      this.setState({snackbarMessageId: null, snackbarType: null});
    };
    return (
      <Snackbar open={snackbarMessageId != null} autoHideDuration={SNACKBAR_AUTO_HIDE_DURATION} onClose={onClose}>
        <MuiAlert severity={snackbarType || "success"} onClose={onClose} elevation={6} variant="filled">
          {snackbarMessageId ? <FormattedMessage id={snackbarMessageId} /> : null}
        </MuiAlert>
      </Snackbar>
    );
  }

  handleMultiSelect(name, values) {
    const {filterObjs, filters} = this.state;
    if (!values) {
      values = [];
    }
    const newFilters = cloneDeep(filters);
    const newFilterObjs = cloneDeep(filterObjs);
    newFilters[name] = [];
    newFilterObjs[name] = [];
    values.forEach((item) => {
      newFilters[name].push(item.value);
      newFilterObjs[name].push(item);
    });

    this.setState({
      filters: newFilters,
      filterObjs: newFilterObjs,
      selectedFilters: [
        ...this.state.selectedFilters,
        {type: name, name: name, value: newFilters[name]}
      ]
    }, () => {
      const {searchText, filters} = this.state;
      this.fetchActivities(searchText, 1, null, filters)
    });
  }

  handleOnSelectChange = (e) => {
    const {
      target: {
        name,
        value
      }
    } = e;
    let {
      filters,
      searchText,
    } = this.state;
    const optionText = e.target.options[e.target.selectedIndex].text;

    if (filters[name].indexOf(value) >= 0) {
      return;
    }

    filters = cloneDeep(filters);
    filters[name].push(value);

    this.setState({
      filters,
      selectedFilters: [
        ...this.state.selectedFilters,
        { type: name, name: optionText, value: value }
      ]
    }, () => {
      this.fetchActivities(searchText, 1, null, filters)
    });
  }

  fetchLocalities = (value) => {
    const { fetchLocalities } = this.props;

    if (value) {
      fetchLocalities(value);
    }
  }

  handleSearchChangeLocalities = (event, { newValue }) => {
    this.setState({ localitySearch: newValue });
  }

  renderSuggestion = (suggestion) => {
    return (
      <span>
        {suggestion.name}
      </span>
    );
  }

  onSuggestionsFetchRequestedLocalities = ({ value }) => {
    this.fetchLocalities(value);
  }

  onSuggestionsClearRequestedLocalities = () => {
    const { resetLocalitiesData } = this.props;

    this.fetchLocalities.cancel();
    resetLocalitiesData();
  }
  onSuggestionSelectedLocality = (event, { suggestion }) => {
    const value = suggestion.id;
    let {
      searchText,
      filters
    } = this.state;

    if (filters.localityIds.indexOf(value) >= 0) {
      return;
    }

    filters = cloneDeep(this.state.filters);
    filters.localityIds.push(value);

    this.setState({
      localitySearch: '',
      filters: filters,
      selectedFilters: [...this.state.selectedFilters, { type: 'localityIds', name: suggestion.name, value }]
    }, () => {
      this.fetchActivities(searchText, 1, null, filters);
    });
  }

  removeSelectedFilter = (selectedFilter) => {
    const filters = cloneDeep(this.state.filters);

    this.setState({
      selectedFilters: filter(this.state.selectedFilters, (filter) => {
        return (filter.type !== selectedFilter.type) || (filter.name !== selectedFilter.name);
      })
    });

    filters[selectedFilter.type] = filter(filters[selectedFilter.type], (value) => {
      return value !== selectedFilter.value;
    });

    this.setState({ filters }, () => {
      this.fetchActivities(this.state.searchText, 1, null, filters);
    });
  }

  getColumns() {
    return [{
      dataField: 'state',
      text: '',
      headerFormatter: () => <FormattedMessage id='admin.availability' />,
      sort: false,
      formatter: this.availabilityCellFormatter
    }, {
      dataField: 'type',
      text: '',
      headerFormatter: () => <FormattedMessage id='admin.type' />,
      sort: false,
      formatter: this.typeCellFormatter
    }, {
      dataField: 'id',
      text: '',
      headerFormatter: () => <FormattedMessage id='generic.id' />,
      sort: false,
    }, {
      dataField: 'title',
      text: '',
      headerFormatter: () => <FormattedMessage id='admin.activity.table.title' />,
      sort: false
    }, {
      dataField: 'business.name',
      text: '',
      headerFormatter: () => <FormattedMessage id='admin.activity.business' />,
      sort: false
    }, {
      dataField: 'startAt',
      text: '',
      headerFormatter: () => <FormattedMessage id='generic.start_date' />,
      headerStyle: { maxWidth: 60, textAlign: 'center' },
      sort: false,
      formatter: this.startDateCellFormatter
    }, {
      dataField: 'endAt',
      text: '',
      headerFormatter: () => <FormattedMessage id='generic.end_date' />,
      headerStyle: { maxWidth: 60, textAlign: 'center' },
      sort: false,
      formatter: this.endDateCellFormatter
    }, {
      dataField: 'displayedCount',
      text: '',
      align: 'center',
      headerFormatter: () => <FormattedMessage id='admin.activity.table.reaches' />,
      sort: false
    }, {
      dataField: 'answeredCount',
      text: '',
      align: 'center',
      headerFormatter: () => <FormattedMessage id='admin.activity.table.actions' />,
      formatter: this.actionsCountCellFormatter,
      sort: false
    }, {
      dataField: 'spamCount',
      text: '',
      align: 'center',
      headerFormatter: () => <FormattedMessage id='admin.activity.table.spams' />,
      sort: false
    }];
  }

  availabilityCellFormatter(cell, row) {
    switch(row.state) {
      case 0: return <FormattedMessage id='admin.deleted' />;
      case 1: return <FormattedMessage id='generic.active' />;
      case 2: return <FormattedMessage id='generic.inactive' />;
      case 3: return <FormattedMessage id='admin.activity.state.suspended' />;
      case 72: return <FormattedMessage id='admin.activity.state.waiting' />;
    }
  }

  availabilityCellColor(cell, row) {
    switch(row.state) {
      case 0: return ColorNegative;
      case 1: return ColorGreen;
      case 2: return ColorOrange;
      case 3: return ColorNegative;
      case 72: return ColorSubTitle;
    }
  }

  typeCellFormatter(cell, row) {
    return get(filter(filtersUtil.getActivityTypes(), ['value', row.type]), '[0].label') || '';
  }

  startDateCellFormatter(cell, row) {
    return DateTimeHelper.getInputDateString(row.startAt) +"\n"+ DateTimeHelper.getInputTimeString(row.startAt);
  }

  endDateCellFormatter(cell, row) {
    return DateTimeHelper.getInputDateString(row.endAt) +"\n"+ DateTimeHelper.getInputTimeString(row.endAt);
  }

  hasCommentAccess = (activity) => {
    const { user } = this.props;

    switch (activity.type) {
      // case constants.activity.types.BUYER_OPINION: {
      //   return user.access.includes(constants.access.types.ACCESS_BUYER_OPINION_COMMENT);
      // }
      case constants.activity.types.EMPLOYEE_OFFER: {
        return false;
      }
      case constants.activity.types.OFFER: {
        return user.access.includes(constants.access.types.ACCESS_OFFER_COMMENT);
      }
      case constants.activity.types.QUESTION: {
        return user.access.includes(constants.access.types.ACCESS_QUESTION_COMMENT);
      }
      case constants.activity.types.SMART_AD: {
        return user.access.includes(constants.access.types.ACCESS_AD_COMMENT);
      }
      // case constants.activity.types.VISITOR_OPINION: {
      //   return user.access.includes(constants.access.types.ACCESS_VISITOR_OPINION_COMMENT);
      // }
      default: {
        return false;
      }
    }
  }

  hasManageAccess = () => {
    const { user } = this.props;
    return user.access.includes(constants.access.types.ACCESS_ACTIVITY_MANAGE);
  }

  actionsCountCellFormatter = (cell, row) => {
    if (row.type === constants.activity.types.SMART_AD
      || row.type === constants.activity.types.BUYER_OPINION
      || row.type === constants.activity.types.VISITOR_OPINION
      || row.type === constants.activity.types.EVENT
    ) {
      return row.clickedCount;
    } else if (row.type === constants.activity.types.QUESTION) {
      return row.answeredCount;
    } else if (row.type === constants.activity.types.CHALLENGE
      || row.type === constants.activity.types.SOCIAL_CONTENT
    ) {
      return row.commentsCount;
    }
    return row.consumedCount;
  }

  answeredCountFormatter = (cell, row) => {
    return row.type === constants.activity.types.QUESTION ? (
      <Button size="sm" variant="primary" onClick={() => this.showActivityAnswersModal(row.id)}>
        <span>{row.answeredCount}</span>
      </Button>
    ) : null;
  }

  getHeaderTitleId() {
    // if (this.readOnly || this.props.activities.paginated.data.length === 0) {
    //   return null;
    // }
    if (this.isShowingRewards()) {
      return 'menu.myRewards';
    }
    if (this.getCampaignUsageType() === constants.activity.usageTypes.MARKETING) {
      return 'generic.marketingCampaigns';
    }
    if (this.getCampaignUsageType() === constants.activity.usageTypes.LOYALTY) {
      return 'generic.loyaltyCampaigns';
    }
    if (this.getCampaignUsageType() === constants.activity.usageTypes.EDUCATION) {
      return 'generic.educationCampaigns';
    }
    if (this.getCampaignUsageType() === constants.activity.usageTypes.TRAINING) {
      return 'generic.trainingCampaigns';
    }
    if (this.getCampaignUsageType() === constants.activity.usageTypes.SOCIAL) {
      return 'generic.socialCampaigns';
    }
    if (this.getCampaignUsageType() === constants.activity.usageTypes.INFLUENCER) {
      return 'generic.influencerCampaigns';
    }
    return 'menu.campaigns';
  }

  tableRowClasses(row) {
    switch (row.state) {
      case constants.activity.state.INACTIVE: return 'disabled';
      case constants.activity.state.APPROVAL_PENDING: return 'text-warning';
      case constants.activity.state.REJECTED: return 'text-danger';
      case constants.activity.state.WAITING: return 'text-yellow';
    }
  }

  onChangeSearchInput = (e) => {
    this.setState({
      searchText: e.target.value
    });
  }

  handleKeyPress = (e) => {
    const {searchText, filters} = this.state;
    // Enter key
    if(e.keyCode == 13) {
      this.fetchActivities(searchText, 1, null, filters);
    }
  }

  onClickSearch = () => {
    const {searchText, filters} = this.state;
    this.fetchActivities(searchText, 1, null, filters);
  }

  onClickClearSearch = () => {
    this.setState({searchText: ''}, () => {
      const { searchText, filters } = this.state;
      this.fetchActivities(searchText, 1, null, filters);
    });
  }

  onClickAddNew(usageType) {
    // if (!this.isUserActive()) {
    //   return;
    // }
    if (this.isShowingRewards()) {
      this.pushTo({pathname: '/rewards/manage', state: {fromLocation: this.props.history.location}}, true);
    } else {
      if (usageType === undefined) {
        usageType = this.getCampaignUsageType();
      }
      if (usageType > 0) {
        this.pushTo({pathname: '/campaigns/manage', search: '?ut='+ usageType, state: {fromLocation: this.props.history.location}}, true);
      } else {
        this.pushTo({pathname: '/campaigns/manage', state: {fromLocation: this.props.history.location}}, true);
      }
    }
  }

  onJoinUsClicked = () => {
    this.props.history.push(PathJoin);
  };

  onAboutUsClicked = () => {
    this.props.history.push(PathAboutUsPublic);
  };

  onHowItWorksClicked = () => {
    this.props.history.push(PathHowItWorks);
  };

  onAddNewCampaign = () => {
    if (!this.isUserActive()) {
      return;
    }
    this.pushTo({pathname: '/campaigns/manage', state: {fromLocation: this.props.history.location}}, true);
  }

  isUserActive() {
    if (!this.props.user.isEmailActive) {
      this.showAccountActivationPendingDialog();
      return false;
    }
    return true;
  }

  showDisplayCriteriaModal = (activityId) => {
    return this.props.fetchActivity(activityId, 1)
      .then(() => {
        this.props.showDisplayCriteriaModal();
      });
  }

  showActivityAnswersModal = (activityId) => {
    return this.props.fetchActivityAnswers(activityId)
      .then(() => {
        this.props.showActivityAnswersModal(activityId);
      });
  }

  isItemReward(item) {
    return item.type === constants.activity.types.OFFER
      || item.type === constants.activity.types.DISCOUNT
      || item.type === constants.activity.types.VOUCHER;
  }

  onClickToggleItem = (item) => {
    this.onCloseMore();
    if (item.demo) {
      this.showPromptForLimitedDemoCampaign();
      return;
    }

    this.setState({
      showStateChangeModal: true,
      activityData: item
    });
  };

  onClickLink = (item, type) => {
    const {classes, isXS} = this.props;
    this.onCloseMore();

    // const hasNoPlan = !item.ad || item.ad.planType <= constants.activity.plans.NO_PLAN;
    // if (hasNoPlan) {
    //   this.setState({snackbarMessageId: 'campaign.subscribePlanToProceed', snackbarType: 'error'});
    //   return;
    // }

    const ad = item.ad;

    // const showNormal = ad && ad.planType > constants.activity.plans.FREE_PLAN && (type === 0 || type === 1);
    // const showDirect = type === 0 || type === 2;
    const showNormal = true;
    const showDirect = false;

    const content = (
      <div className={classes.viewColumnFullWidth}>
        <div className={isXS ? classes.viewColumn : classes.flexRowNoCenter}>
          {showNormal ?
            <div className={classes.flexColumn}>
              {/*<Typography variant={'body1'} className={classes.typoBold} color={'primary'} >{<FormattedMessage id={'activity.manage.normalLink'} />}</Typography>*/}
              {/*<Space horizontal={4} />*/}
              {/*<Typography variant={'body2'} color={'textSecondary'} align={'center'}>{<FormattedMessage id={'activity.manage.normalLinkDetail'} />}</Typography>*/}
              {/*<Space horizontal={FIELD_SPACE} />*/}
              <div style={{height: "auto", maxWidth: 300, width: "100%"}}>
                <QRCode
                  id={'QRCodeShare'}
                  size={300}
                  style={{height: "auto", maxWidth: "100%", width: "100%"}}
                  value={item.shUrl}
                  viewBox={`0 0 300 300`}
                  level={'M'}
                />
              </div>
              <Space horizontal={FIELD_SPACE} />
              <div className={classes.viewFullWidthWrapCenter}>
                <Button
                  size={'small'}
                  variant={'outlined'}
                  color={"secondary"}
                  onClick={() => {
                    this.downloadQRCode(item.id, 'QRCodeShare');
                    this.setState({snackbarMessageId: 'activity.manage.normalQRCopied'})
                  }}
                  className={classes.buttonCamelCase}>
                  {<FormattedMessage id='activity.manage.downloadQR' />}
                </Button>
                <Space vertical={FIELD_SPACE/2} />
                <Button
                  size={'small'}
                  variant={'outlined'}
                  color={"secondary"}
                  onClick={() => {
                    navigator.clipboard.writeText(item.shUrl);
                    this.setState({snackbarMessageId: 'activity.manage.shareLinkCopied'})
                    // const fallback = () => {
                    //   this.setState({snackbarMessageId: 'activity.manage.shareLinkCopied'})
                    // };
                    // AppUtils.shareActivity(item, this.context.intl, item.shUrl, fallback);
                  }}
                  className={classes.buttonCamelCase}>
                  {<FormattedMessage id='activity.manage.copyLink' />}
                </Button>
                {/*<Space vertical={FIELD_SPACE/2} />*/}
                {/*<Button*/}
                {/*  size={'small'}*/}
                {/*  variant={'outlined'}*/}
                {/*  color={"secondary"}*/}
                {/*  onClick={() => {*/}
                {/*    navigateToPlay(item)*/}
                {/*  }}*/}
                {/*  className={classes.buttonCamelCase}>*/}
                {/*  {<FormattedMessage id='activity.openLink' />}*/}
                {/*</Button>*/}
              </div>
              <Space horizontal={FIELD_SPACE} />
            </div>
            : null
          }
          {showNormal && showDirect ?
            <Space vertical={!isXS ? 2 * FIELD_SPACE : 0} horizontal={isXS ? 4 * FIELD_SPACE : 0} />
            : null
          }

          {showDirect ?
            <div className={classes.flexColumn} >
              <Typography variant={'body1'} className={classes.typoBold} color={'primary'} >{<FormattedMessage id={'activity.manage.directLink'} />}</Typography>
              <Space horizontal={4} />
              <Typography variant={'body2'} color={'textSecondary'} align={'center'}>{<FormattedMessage id={ad && ad.planType > 2 ? 'activity.manage.directLinkDetail' : 'activity.manage.directLinkDetailFree'} />}</Typography>
              <Space horizontal={FIELD_SPACE} />
              <div style={{height: "auto", maxWidth: 300, width: "100%"}}>
                <QRCode
                  id={'QRCodeDirectAccess'}
                  size={300}
                  style={{height: "auto", maxWidth: "100%", width: "100%"}}
                  value={APP_URI + getPathForActivity(item) +'/'+ item.sId}
                  viewBox={`0 0 300 300`}
                  level={'M'}
                />
              </div>
              <Space horizontal={FIELD_SPACE} />
              <div className={classes.viewRow}>
                <Button
                  size={'small'}
                  variant={'outlined'}
                  color={"primary"}
                  onClick={() => {
                    this.downloadQRCode(item.id, 'QRCodeDirectAccess');
                    this.setState({snackbarMessageId: 'activity.manage.directQRCopied'})
                  }}
                  className={classes.buttonCamelCase}>
                  {<FormattedMessage id='activity.manage.downloadQR' />}
                </Button>
                <Space vertical={FIELD_SPACE/2} />
                <Button
                  size={'small'}
                  variant={'outlined'}
                  color={"primary"}
                  onClick={() => {
                    navigator.clipboard.writeText(APP_URI + getPathForActivity(item) +'/'+ item.sId);
                    this.setState({snackbarMessageId: 'activity.manage.directLinkCopied'})
                  }}
                  className={classes.buttonCamelCase}>
                  {<FormattedMessage id='activity.manage.copyLink' />}
                </Button>
              </div>
              <Space horizontal={FIELD_SPACE} />
            </div>
            : null
          }
        </div>
      </div>
    );

    const dialogInfo = {
      // title: <FormattedMessage id={'activity.manage.shareLink'} />,
      content: content,
      positiveText: <FormattedMessage id={'activity.manage.close'} />,
      onPositiveClicked: () => {
        this.hideDialog();
      },
    };
    this.showDialog(dialogInfo);
  };

  onClickViewCampaign = (item) => {
    this.onCloseMore();

    // const hasNoPlan = !item.ad || item.ad.planType <= constants.activity.plans.NO_PLAN;
    // if (hasNoPlan) {
    //   this.setState({snackbarMessageId: 'campaign.subscribePlanToProceed', snackbarType: 'error'});
    //   return;
    // }

    // LinkHelper.open(`${window.location.origin}/#/${getPathForActivity(item)}/${item.id}`, true);
    this.pushTo({
      pathname: getPathForActivity(item) +'/'+ item.id,
      state: {canGoBack: true}
    }, true);
  };

  onClickViewPlan = (item) => {
    const {classes, isXS} = this.props;
    this.onCloseMore();

    const content = this.getSubscriptionPlanView(item, true);
    const isPlanEnded = isCurrentPlanEnded(item.ad);
    let positiveText = null;
    let onPositiveClicked = null;
    let neutralText = null;
    let onNeutralClicked = null;
    if (isPlanEnded) {
      positiveText = <FormattedMessage id={'activity.manage.actionRenewL'} />;
      onPositiveClicked = this.onClickPromote.bind(this, item);
      neutralText = <FormattedMessage id={'activity.manage.close'} />;
      onNeutralClicked = () => {
        this.hideDialog();
      };
    } else if (isCurrentPlanViewEnded(item.ad)) {
      positiveText = <FormattedMessage id={isCurrentPlanPaid(item.ad) ? 'activity.manage.actionExtendL' : 'activity.manage.actionUpgradeL'} />;
      onPositiveClicked = this.onClickPromote.bind(this, item);
      neutralText = <FormattedMessage id={'activity.manage.close'} />;
      onNeutralClicked = () => {
        this.hideDialog();
      };
    } else {
      positiveText = <FormattedMessage id={'activity.manage.close'} />;
      onPositiveClicked = () => {
        this.hideDialog();
      };
    }

    const dialogInfo = {
      // title: <FormattedMessage id={'activity.plan.campaignPlan'} />,
      content: content,
      positiveText: positiveText,
      onPositiveClicked: onPositiveClicked,
      neutralText: neutralText,
      onNeutralClicked: onNeutralClicked,
    };
    this.showDialog(dialogInfo);
  };

  downloadQRCode(id, qrCodeId) {
    const qrCodeElement = document.getElementById(qrCodeId);
    const serializeToString = (new XMLSerializer).serializeToString(qrCodeElement);
    const canvasElement = document.createElement("canvas");
    const context = canvasElement.getContext("2d");
    const image = new Image;
    image.onload = () => {
      const padding = 20;
      canvasElement.width = 600;
      canvasElement.height = 600;
      context.fillStyle = "white";
      context.fillRect(0, 0, canvasElement.width, canvasElement.height);
      context.drawImage(image, padding, padding, canvasElement.width - 2 * padding, canvasElement.height - 2 * padding);

      const dataURL = canvasElement.toDataURL("image/png");
      const anchorElement = document.createElement("a");
      anchorElement.download = qrCodeId +'-'+ id;
      anchorElement.href = "".concat(dataURL);
      anchorElement.click();

    };
    image.src = "data:image/svg+xml;base64,".concat(btoa(serializeToString));
  }

  showPromptForLimitedDemoCampaign = () => {
    const dialogInfo = {
      message: <FormattedHTMLMessage id={'activity.demoCampaignPrompt'} />,
      positiveText: <FormattedMessage id={'generic.ok'} />,
      onPositiveClicked: this.hideDialog
    };
    this.showDialog(dialogInfo);
  };

  onClickEndCampaign = (item) => {
    this.onCloseMore();
    if (item.demo) {
      this.showPromptForLimitedDemoCampaign();
      return;
    }

    const dialogInfo = {
      title: <FormattedMessage id={'campaign.endCampaign'} />,
      message: <FormattedHTMLMessage id={'campaign.endCampaignPrompt'} />,
      positiveText: <FormattedMessage id={'campaign.endCampaign'} />,
      onPositiveClicked: this.onDeclareWinnersPromptProceedClicked.bind(this, item, 0),
      neutralText: <FormattedMessage id={'generic.cancel'} />,
      onNeutralClicked: this.onCancelDeclareWinnersClicked,
    };
    this.showDialog(dialogInfo);
  };

  onClickDeclareWinners = (item) => {
    this.onCloseMore();
    if (item.demo) {
      this.showPromptForLimitedDemoCampaign();
      return;
    }

    const dialogInfo = {
      title: <FormattedMessage id={'campaign.declareWinners'} />,
      message: <FormattedMessage id={'campaign.declareWinnersPrompt'} />,
      renderContent: this.getDynamicContentToChangeDeclareWinnersOption,
      positiveText: <FormattedMessage id={'campaign.declareWinners'} />,
      onPositiveClicked: this.onDeclareWinnersClicked.bind(this, item),
      neutralText: <FormattedMessage id={'activity.manage.close'} />,
      onNeutralClicked: this.onCancelDeclareWinnersClicked,
    };
    this.showDialog(dialogInfo);
  };

  getDynamicContentToChangeDeclareWinnersOption = () => {
    const {classes} = this.props;
    return (
      <RadioGroup name="declareWinnersOption" value={this.state.declareWinnersOption} onChange={this.onChangeDeclareWinnersOption}>
        <div className={classes.viewRowFullWidthNoCenter} style={{paddingLeft: app.isLTR ? 0 : 12, paddingRight: app.isLTR ? 12 : 0}}>
          <div className={classes.viewColumn}>
            <FormControlLabel style={{minWidth: 95, marginRight: 0}} value={"2"} control={<Radio color={'primary'}/>} label={
              <div className={classes.viewColumn}>
                <FormattedMessage id={'campaign.declareWinnersNEndCampaign'} />
                <TextView textAlign={'left'} color={ColorSubTitle} variant={'caption'} style={{}}>{<FormattedMessage id={'campaign.declareWinnersNEndCampaignHint'} />}</TextView>
              </div>
            } />
          </div>
        </div>
        <Space horizontal={4}/>
        <div className={classes.viewRowFullWidthNoCenter} style={{marginTop: 12, paddingLeft: app.isLTR ? 0 : 12, paddingRight: app.isLTR ? 12 : 0}}>
          <div className={classes.viewColumn}>
            <FormControlLabel style={{minWidth: 95, marginRight: 0}} value={"1"} control={<Radio color={'primary'}/>} label={
              <div className={classes.viewColumn}>
                <FormattedMessage id={'campaign.declareWinnersNRestartCampaign'} />
                <TextView textAlign={'left'} color={ColorSubTitle} variant={'caption'}>{<FormattedMessage id={'campaign.declareWinnersNRestartCampaignHint'} />}</TextView>
              </div>
            } />
          </div>
        </div>
        <Space horizontalSpace={2}/>
      </RadioGroup>
    );
  }

  onChangeDeclareWinnersOption = (event) => {
    this.setState({declareWinnersOption: event.target.value});
  }

  onCancelDeclareWinnersClicked = () => {
    this.hideDialog({declareWinnersOption: "0"});
  }

  onDeclareWinnersClicked = (item) => {
    const declareWinnersOption = this.state.declareWinnersOption;
    if (!declareWinnersOption || declareWinnersOption === "0") {
      this.setState({snackbarMessageId: 'campaign.chooseDeclareWinnersOption', snackbarType: 'info'});
      return;
    }

    this.hideDialog({declareWinnersOption: "0"}, () => {
      const dialogInfo = {
        title: <FormattedMessage id={declareWinnersOption === "1" ? 'campaign.declareWinnersNRestartCampaignQ' : 'campaign.declareWinnersNEndCampaignQ'} />,
        message: <FormattedHTMLMessage id={declareWinnersOption === "1" ? 'campaign.declareWinnersNRestartCampaignPrompt' : 'campaign.declareWinnersNEndCampaignPrompt'} />,
        positiveText: <FormattedMessage id={'generic.yes'} />,
        onPositiveClicked: () => this.onDeclareWinnersPromptProceedClicked(item , declareWinnersOption),
        neutralText: <FormattedMessage id={'generic.no'} />,
        onNeutralClicked: this.hideDialog,
      };
      this.showDialog(dialogInfo);
    });
  };

  onDeclareWinnersPromptProceedClicked = (item, declareWinnersOption) => {
    this.hideDialog();
    this.props.declareCampaignWinners(item.id, {type: declareWinnersOption});
  }

  onClickDeleteItem = (item, index) => {
    this.onCloseMore();
    if (item.demo) {
      this.showPromptForLimitedDemoCampaign();
      return;
    }

    this.setState({
      showDeleteModal: true,
      activityData: item,
      activityIndex: index
    });
  };

  onClickPromote = (item) => {
    if (item.demo) {
      this.showPromptForLimitedDemoCampaign();
      return;
    }
    if (item.type === constants.activity.types.SHOWCASE_MENU) {
      this.onClickEdit(item);
      return;
    }

    // if (isCurrentPlanPaid(item.ad) && !isCurrentPlanEnded(item.ad)) {
    //   const content = this.getSubscriptionPlanView(item, true, true);
    //   const dialogInfo = {
    //     title: <FormattedMessage id={'activity.plan.campaignPlan'} />,
    //     content: content,
    //     positiveText: <FormattedMessage id={'activity.manage.close'} />,
    //     onPositiveClicked: () => {
    //       this.hideDialog();
    //     },
    //   };
    //   this.showDialog(dialogInfo);
    //
    //   return;
    // }

    let search = '?p=2';
    // if (isCurrentPlanEnded(item.ad)) {
    //   search = '?p=3';
    // } else if (isCurrentPlanPaid(item.ad)) {
    //   search = '?p=2';
    // } else {
    //   search = '?p=1';
    // }
    const pathName = this.getEditBasePathname(item) + item.id;

    // if (!this.props.user.registerType) {
    //   this.props.history.push({
    //     pathname: PathJoin,
    //     search: getRedirectSearch({
    //       pathname: pathName,
    //       search: search,
    //     }),
    //   });
    //   return;
    // }

    this.pushTo({
      pathname: pathName,
      search: search,
      state: {canGoBack: true, fromLocation: this.props.history.location}
    }, true);
  };

  onClickEdit = (item) => {
    this.onCloseMore();

    if (item.demo) {
      this.showPromptForLimitedDemoCampaign();
      return;
    }

    this.pushTo({
      pathname: this.getEditBasePathname(item) + item.id,
      state: {canGoBack: true, fromLocation: this.props.history.location}
    }, true);
  };

  onClickInsight = (item) => {
    this.onCloseMore();

    // const hasNoPlan = !item.ad || item.ad.planType <= constants.activity.plans.NO_PLAN;
    // if (hasNoPlan) {
    //   this.setState({snackbarMessageId: 'campaign.subscribePlanToProceed', snackbarType: 'error'});
    //   return;
    // }

    const showRating = item.type === constants.activity.types.VISITOR_OPINION && item.contentTypes && item.contentTypes.includes(5);
    const path = getActivityInsightNavPath(item.id, item.type, showRating);
    path.state = {canGoBack: true, fromLocation: this.props.history.location, model: item};
    this.pushTo(path, true);
  };

  onClickAnswerDistribution = (item) => {
    this.onCloseMore();
    const {isXS} = this.props;
    let activity = item;
    if (item.questionId > 0) {
      activity = {
        id: item.questionId,
        type: constants.activity.types.QUESTION
      };
    }
    this.showDialog({
      renderContent: () => {
        const style = isXS ? {
          width: '100%',
          minHeight: window.appHeight - 128,
        } : {
          width: Math.min(window.appWidth, 500),
          height: Math.min(window.appHeight, 680),
          minHeight: Math.min(window.appHeight, 680),
        };
        const uiConfigs = {
          sizeFactor: 1,
          bgColor: ColorWhite,
          safeAreaColor: ColorWhite,
          actionTitleColor: ColorTheme,
          titleColor: ColorTitle,
          subTitleColor: ColorSubTitle,
          messageBorderColor: ColorTheme,
          gameValueTextColor: ColorTitle,
        }
        return (
          <div style={{display: 'flex', flex: 1, flexDirection: 'column', ...style}}>
            <ActivityAnswerDistributions activity={activity} forUser={false} uiConfigs={uiConfigs} />
          </div>
        )
      },
      fullScreen: isXS,
      positiveText: locString('close'),
      onPositiveClicked: this.hideDialog,
      marginTop: 1,
    });
  };

  onClickGuessDistribution = (item) => {
    this.onCloseMore();

    const {isXS} = this.props;
    let activity = item;
    this.showDialog({
      renderContent: () => {
        const style = isXS ? {
          width: '100%',
          minHeight: window.appHeight - 128,
        } : {
          width: Math.min(window.appWidth, 500),
          height: Math.min(window.appHeight, 680),
          minHeight: Math.min(window.appHeight, 680),
        };
        const uiConfigs = {
          sizeFactor: 1,
          bgColor: ColorWhite,
          safeAreaColor: ColorWhite,
          actionTitleColor: ColorTheme,
          titleColor: ColorTitle,
          subTitleColor: ColorSubTitle,
          messageBorderColor: ColorTheme,
          gameValueTextColor: ColorTitle,
        }
        return (
          <div style={{display: 'flex', flex: 1, flexDirection: 'column', ...style}}>
            <ActivityAnswerDistributions activity={activity} forUser={false} uiConfigs={uiConfigs} />
          </div>
        )
      },
      fullScreen: isXS,
      positiveText: locString('close'),
      onPositiveClicked: this.hideDialog,
      marginTop: 1,
    });
  };

  onClickShowWinners = (item) => {
    this.onCloseMore();
    const {isXS} = this.props;
    this.showDialog({
      renderContent: () => {
        const style = isXS ? {
          width: '100%',
          minHeight: window.appHeight - 128,
        } : {
          width: Math.min(window.appWidth, 500),
          height: Math.min(window.appHeight, 780),
          minHeight: Math.min(window.appHeight, 780),
        };
        const uiConfigs = {
          sizeFactor: 1,
          bgColor: ColorWhite,
          safeAreaColor: ColorWhite,
          actionTitleColor: ColorTheme,
          titleColor: ColorTitle,
          subTitleColor: ColorSubTitle,
          messageBorderColor: ColorTheme,
          gameValueTextColor: ColorTitle,
        }
        return (
          <div style={{display: 'flex', flex: 1, flexDirection: 'column', ...style}}>
            <ActivityWinners activityId={item.id} forUser={false} uiConfigs={uiConfigs} showNotify={true} />
          </div>
        )
      },
      fullScreen: isXS,
      positiveText: locString('close'),
      onPositiveClicked: this.hideDialog,
      marginTop: 1,
    });
  };

  onClickActivityReviews = (item) => {
    const path = getActivityReviewsNavPath(item.id, item.type);
    path.state = {canGoBack: true, fromLocation: this.props.history.location, model: item};
    this.pushTo(path, true);
  };

  getSubscriptionPlanView(item, inDialog, showPlanActiveMessage) {
    const {classes} = this.props;
    const plan = item.ad;

    let totalViewsText;
    if (plan.planViewsCount >= constants.activity.VALUE_DEFAULT_MAX) {
      totalViewsText = <FormattedMessage id={'activity.plan.unlimited'} />
    } else {
      totalViewsText = ValueHelper.getDisplayValue(plan.planViewsCount);
    }
    let totalDailyViewsText;
    if (plan.planDailyViewsCount >= constants.activity.VALUE_DEFAULT_MAX) {
      totalDailyViewsText = <FormattedMessage id={'activity.plan.unlimited'} />
    } else {
      totalDailyViewsText = ValueHelper.getDisplayValue(plan.planDailyViewsCount);
    }
    const availableViews = Math.max(0, plan.planViewsCount - plan.feedDisplayedCount);
    let availableViewsText;
    if (availableViews >= 10000000) {
      availableViewsText = <FormattedMessage id={'activity.plan.unlimited'} />
    } else {
      availableViewsText = ValueHelper.getDisplayValue(availableViews);
    }

    let isPlanEnded = false;
    let isPlanViewsEnded = false;
    let endAtLabelText = '';
    let endAtText = '';
    let endAtDateText = null;
    let startAtText = '';
    let startAtDateText = null;
    let startDateColor = ColorTitle;
    let endDateColor = ColorTitle;
    const planEndAt = plan.planEndAt;
    const startDateDiff = DateTimeHelper.getSecondsDiffFromNow(item.startAt);
    const endDateDiff = DateTimeHelper.getSecondsDiffFromNow(planEndAt);
    if (startDateDiff <= 0) {
      startAtText = DateTimeHelper.getSince(item.startAt, 'time.since');
      if (endDateDiff > 0) {
        startDateColor = ColorGreen;
      }
    } else {
      startAtText = DateTimeHelper.getValidityInTime(item.startAt);
    }
    startAtDateText = DateTimeHelper.getInputDateTimeString(item.startAt);
    endAtDateText = DateTimeHelper.getInputDateTimeString(planEndAt);
    if (endDateDiff > 0) {
      endAtText = DateTimeHelper.getValidityInTime(planEndAt);
      if (startDateDiff <= 0) {
        endDateColor = ColorGreen;
      }
    }
    if (endDateDiff <= 0) {
      endDateColor = ColorNegative;
      endAtText = <FormattedMessage id='generic.ended' />;
      isPlanEnded = true;
    } else {
      isPlanViewsEnded = availableViews === 0;
    }

    const onClick = () => {
      if (inDialog) {
        this.hideDialog();
      }
      this.onClickPromote(item);
    };

    return (
      <div className={classes.planCard}>
        <div className={classes.flexColumnNoCenter} style={{}}>
          {/*<div className={classes.viewRowFullWidth} style={{justifyContent: 'center'}}>*/}
          {/*  <TextView text={plan.planName} variant="h6" color={ColorTheme} fontWeight={FONT_WEIGHT_MEDIUM} />*/}
          {/*</div>*/}
          {/*<Space horizontalSpace={1.5}/>*/}

          <div className={classes.viewColumnFullWidthNoCenter} style={{minWidth: 300}}>
            <div className={classes.viewRowFullWidth} style={{padding: 12}}>
              <TextView textId={'activity.plan.totalViews'} variant="subtitle1" color={ColorTitle} />
              <div className={classes.flexGrow} />
              <TextView text={totalViewsText} variant="subtitle1" color={ColorTitle} fontWeight={FONT_WEIGHT_MEDIUM} />
            </div>
            <Divider style={{width: '100%', backgroundColor: ColorTableBorder}} />
            {/*<Space horizontalSpace={0.8}/>*/}
            {/*<div className={classes.viewRowFullWidth} style={{padding: 12}}>*/}
            {/*  <TextView textId={'activity.plan.dailyViews'} variant="subtitle1" color={ColorTitle} />*/}
            {/*  <div className={classes.flexGrow} />*/}
            {/*  <TextView text={totalDailyViewsText} variant="subtitle1" color={ColorTitle} fontWeight={FONT_WEIGHT_MEDIUM} />*/}
            {/*</div>*/}
            {/*<Divider style={{width: '100%', backgroundColor: ColorTableBorder}} />*/}
            {!isPlanEnded ?
              <React.Fragment>
                <div className={classes.viewRowFullWidth} style={{padding: 12}}>
                  <TextView textId={'activity.plan.availableViews'} variant="subtitle1" color={ColorTitle} />
                  <div className={classes.flexGrow} />
                  <TextView text={availableViewsText} variant="subtitle1" color={isPlanViewsEnded ? ColorOrange : ColorGreen} fontWeight={FONT_WEIGHT_MEDIUM} />
                </div>
                <Divider style={{width: '100%', backgroundColor: ColorTableBorder}} />
              </React.Fragment>
              : null
            }
            <div className={classes.viewRowFullWidth} style={{padding: 12}}>
              <TextView textId={'activity.planStart'} variant="subtitle1" color={ColorTitle} />
              <div className={classes.flexGrow} />
              <div className={classes.viewColumn} style={{alignItems: 'flex-end'}}>
                {/*<TextView text={startAtText} variant="subtitle1" color={startDateColor} fontWeight={FONT_WEIGHT_MEDIUM} />*/}
                {startAtDateText != null ? <TextView text={startAtDateText} variant="body2" color={startDateColor} />
                  : <TextView text={startAtText} variant="subtitle1" color={startDateColor} fontWeight={FONT_WEIGHT_MEDIUM} />
                }
              </div>
            </div>
            {/*{startAtDateText != null ?*/}
            {/*  <div className={classes.viewRowFullWidth} style={{padding: 12, paddingTop: 0, marginTop: -8}}>*/}
            {/*    <div className={classes.flexGrow} />*/}
            {/*    <div className={classes.viewColumn} style={{alignItems: 'flex-end'}}>*/}
            {/*      <TextView text={startAtDateText} variant="body2" color={startDateColor} />*/}
            {/*    </div>*/}
            {/*  </div>*/}
            {/*  : null*/}
            {/*}*/}
            <Divider style={{width: '100%', backgroundColor: ColorTableBorder}} />
            <div className={classes.viewRowFullWidth} style={{padding: 12}}>
              <TextView textId={'activity.planEnd'} variant="subtitle1" color={ColorTitle} />
              <div className={classes.flexGrow} />
              <div className={classes.viewColumn} style={{alignItems: 'flex-end'}}>
                {/*<TextView text={endAtText} variant="subtitle1" color={endDateColor} fontWeight={FONT_WEIGHT_MEDIUM} />*/}
                {endAtDateText != null ? <TextView text={endAtDateText} variant="body2" color={endDateColor} />
                  : <TextView text={endAtText} variant="subtitle1" color={endDateColor} fontWeight={FONT_WEIGHT_MEDIUM} />
                }
              </div>
            </div>
            {/*<div className={classes.viewRowFullWidth} style={{padding: 12, paddingTop: 0, marginTop: -8}}>*/}
            {/*  <div className={classes.flexGrow} />*/}
            {/*  <div className={classes.viewColumn} style={{alignItems: 'flex-end'}}>*/}
            {/*    <TextView text={endAtDateText} variant="body2" color={endDateColor} />*/}
            {/*  </div>*/}
            {/*</div>*/}
            {isPlanViewsEnded ?
              <React.Fragment>
                <Divider style={{width: '100%', backgroundColor: ColorTableBorder}} />
                <div className={classes.viewColumnFullWidth} style={{padding: 12}}>
                  <TextView textId={'activity.manage.viewLimitOver'} variant="body2" color={ColorOrange} />
                  <TextView textId={isCurrentPlanPaid(plan) ? 'activity.manage.expandToIncreaseViews' : 'activity.manage.upgradeToIncreaseViews'} variant="body2" color={ColorOrange} />
                </div>
              </React.Fragment>
              : null
            }
            {isPlanEnded ?
              <React.Fragment>
                <Divider style={{width: '100%', backgroundColor: ColorTableBorder}} />
                <div className={classes.viewColumnFullWidth} style={{padding: 12}}>
                  <TextView textId={'activity.plan.ended'} variant="body2" color={ColorNegative} textAlign={'center'}/>
                  <TextView textId={'activity.manage.renewToIncreaseViews'} variant="body2" color={ColorNegative} />
                </div>
              </React.Fragment>
              : null
            }
            {/*{showPlanActiveMessage ?*/}
            {/*  <div className={classes.viewColumnFullWidthNoCenter}>*/}
            {/*    <Space horizontalSpace={1.5}/>*/}
            {/*    <Divider style={{width: '100%'}} />*/}
            {/*    <Space horizontalSpace={1.5}/>*/}
            {/*    <TextView textId={'activity.plan.planActiveNoModify'} variant="subtitle1" color={ColorNegative} fontWeight={FONT_WEIGHT_BOLD} textAlign={'center'}/>*/}
            {/*  </div>*/}
            {/*  : null*/}
            {/*}*/}
            {/*{!inDialog && isPlanEnded ?*/}
            {/*  <div className={classes.viewColumn}>*/}
            {/*    <Space horizontalSpace={2}/>*/}
            {/*    <Button*/}
            {/*      disableElevation*/}
            {/*      variant={'contained'}*/}
            {/*      color={"primary"}*/}
            {/*      onClick={onClick}*/}
            {/*      className={classes.buttonCamelCase}>*/}
            {/*      {<FormattedMessage id={'activity.manage.subscribeToPlan'} />}*/}
            {/*    </Button>*/}
            {/*  </div>*/}
            {/*  : null*/}
            {/*}*/}
          </div>
        </div>
      </div>
    );
  }

  getEditBasePathname(item) {
    let pathname;
    if (item.type === constants.activity.types.OFFER
      || item.type === constants.activity.types.DISCOUNT
      || item.type === constants.activity.types.VOUCHER) {
      pathname = '/rewards/manage/';
    } else {
      const usageType = this.getCampaignUsageType();
      if (usageType === constants.activity.usageTypes.MARKETING) {
        pathname = '/marketingCampaigns/manage/';
      } else if (usageType === constants.activity.usageTypes.LOYALTY) {
        pathname = '/loyaltyCampaigns/manage/';
      } else if (usageType === constants.activity.usageTypes.EDUCATION) {
        pathname = '/educationCampaigns/manage/';
      } else if (usageType === constants.activity.usageTypes.TRAINING) {
        pathname = '/trainingCampaigns/manage/';
      } else if (usageType === constants.activity.usageTypes.SOCIAL) {
        pathname = '/socialCampaigns/manage/';
      } else if (usageType === constants.activity.usageTypes.INFLUENCER) {
        pathname = '/influencerCampaigns/manage/';
      } else {
        pathname = '/campaigns/manage/';
      }
    }
    return pathname;
  }

  onClickMore = (item, index, target) => {
    this.setState({showMenuItem: item, showMenuElement: target, showMenuIndex: index});
  };

  onCloseMore = () => {
    this.setState({showMenuItem: null, showMenuElement: null, showMenuIndex: null});
  };

  onClickCopyLink(row) {
    copyTextToClipboard(`https://api.rab7.com/a/${row.id}`);

    toast(() => (
      <FormattedHTMLMessage id='admin.notification.link_copied' values={row} />
    ), {
      containerId: 'toastContainer',
    });
  }

  pushTo(path, cacheCurrent = false) {
    if (cacheCurrent) {
      this.props.cacheListData(this.state.listScrollOffset, FETCH_CACHE_ACTIVITIES, this.props.activities.paginated);
    }

    if (this.readOnly) {
      this.setState({isFetchInProgress: true, showMenuItem: null, showMenuElement: null});
      this.props.doLoginGuest({code: '' + Date.now()}).then(() => {
        // setTimeout(() => {
          history.push(path);
        // }, 100);
      }).catch(() => {
        // setTimeout(() => {
          history.push(path);
        // }, 100);
      });
    } else {
      this.props.history.push(path);
    }
  }

  fetchActivities(search, page, perPage, filters, cache = false, skipPush = false, onLoaded = null) {
    let filterTypes = null;
    let effTypes = this.isShowingRewards()
      ? [constants.activity.types.OFFER,
        constants.activity.types.VOUCHER,
        constants.activity.types.DISCOUNT,
      ] : [constants.activity.types.SMART_AD,
        constants.activity.types.QUESTION,
        constants.activity.types.BUYER_OPINION,
        constants.activity.types.VISITOR_OPINION,
        constants.activity.types.CHALLENGE,
        constants.activity.types.PREDICTION,
        constants.activity.types.JACKPOT,
        constants.activity.types.GAME_FLIP_CARD,
        constants.activity.types.EVENT,
        constants.activity.types.LIKE_USER,
        constants.activity.types.COLLECT_STARS,
        constants.activity.types.GUESS,
        constants.activity.types.GAME_ROULETTE,
        constants.activity.types.SOCIAL_CONTENT,
        constants.activity.types.GAME_SPIN_N_DISCOVER,
        constants.activity.types.GAME_FIND_HIDDEN,
        constants.activity.types.GAME_GREEDY_SPIN,
        constants.activity.types.GAME_BETTING_PIC,
        constants.activity.types.GAME_MATCH_PAIR,
        constants.activity.types.GAME_TIC_TAC_TOE,
        constants.activity.types.QUESTIONNAIRE,
        constants.activity.types.SURVEY,
        constants.activity.types.GAME_MATCH_THREE,
        constants.activity.types.GAME_PUZZLE,
        constants.activity.types.GAME_PUZZLE_SLIDE,
        constants.activity.types.GAME_WHAC_A_MOLE,
        constants.activity.types.GAME_BRAND_RACE,
        constants.activity.types.GAME_POKER,
        constants.activity.types.IDENTIFY_LOCATION,
        constants.activity.types.SLIDES,
        constants.activity.types.SHOWCASE_MENU,
        constants.activity.types.EXTERNAL_GAMES
      ];
    if (filters && filters.types && filters.types.length > 0) {
      filters.types = filters.types.filter(value => effTypes.includes(value));
    } else {
      filterTypes = effTypes;
    }

    let params = [];
    if (search && search.length > 0) {
      params.push('s=' + search);
    }
    if (page > 1) {
      params.push('p=' + page);
    }
    if (filters) {
      let filterKeyValue = this.filterToQueryParam(filters.states, 'fs');
      if (filterKeyValue) {
        params.push(filterKeyValue);
      }
      filterKeyValue = this.filterToQueryParam(filters.types, 'ft');
      if (filterKeyValue) {
        params.push(filterKeyValue);
      }
    }
    // if (!skipPush) {
    //   let hash = '#';
    //   if (params && params.length > 0) {
    //     let count = 0;
    //     params.forEach((param) => {
    //       if (count > 0) {
    //         hash += '&';
    //       }
    //       hash += param;
    //       count++;
    //     });
    //   }
    //   history.push(hash);
    // }

    // set default activity types & usage
    let newFilters = cloneDeep(filters);
    if (filterTypes) {
      if (!newFilters) {
        newFilters = {};
      }
      newFilters.types = filterTypes;
    }
    newFilters.usageTypes = this.getCampaignUsageType();

    this.lastPath = getCompletePath(this.props.history.location, true);

    const {user, activities, history} = this.props;
    page = page || activities.paginated.page;
    perPage = perPage || activities.paginated.perPage;

    if (page === 1) {
      this.setState({isFetchInProgress: true, showMenuItem: null, showMenuElement: null});
    }

    if (cache) {
      this.props.fetchCacheActivities(user.id, search, page, perPage, false, 1, newFilters);
    } else {
      const onResult = (response) => {
        this.setState({isFetchInProgress: false});
        if (onLoaded) {
          onLoaded();
        }
        const isNoUser = !auth.isAuthenticated();
        const isUserGuest = user && !user.registerType;
        const campaigns = response.data ? response.data.data : null;
        if (page === 1 && (isNoUser || isUserGuest) && (!campaigns || campaigns.length === 0 || campaigns[0].demo) && !this.forceDisplay) {
          history.replace({
            pathname: PathLanding,
            search: '?f=1'
          });
        }
      };
      const onError = () => {
        this.setState({isFetchInProgress: false});
        if (onLoaded) {
          onLoaded();
        }
      };
      if (!this.readOnly) {
        this.props.fetchActivities(user.id, search, page, perPage, false, 1, newFilters).then(onResult).catch(onError);
      } else {
        // this.props.doLoginGuest({code: ''+ Date.now()}).then(() => {
        //   this.readOnly = false;
        //   this.fetchData();
        // }).catch(() => {
        //   this.props.fetchOpenActivities(user.id, search, page, perPage, false, 1, newFilters);
        //   setTimeout(() => {
        //     this.setState({isFetchInProgress: false});
        //     if (onLoaded) {
        //       onLoaded();
        //     }
        //   });
        // });

        this.props.fetchOpenActivities(user.id, search, page, perPage, false, 1, newFilters);
        setTimeout(() => {
          this.setState({isFetchInProgress: false});
          if (onLoaded) {
            onLoaded();
          }
        });
      }
    }
  }
}

ActivityLists.propTypes = {
  classes: PropTypes.object,
  location: PropTypes.object,
  user: PropTypes.object,
  activities: PropTypes.object,
  isLoading: PropTypes.bool,
  localities: PropTypes.array,
  hideActivityModal: PropTypes.func,
  resetActivitiesData: PropTypes.func,
  fetchHelp: PropTypes.func,
  fetchActivities: PropTypes.func,
  fetchActivity: PropTypes.func,
  deleteActivity: PropTypes.func,
  toggleActivityState: PropTypes.func,
  resetActivitiesError: PropTypes.func,
  updateActivityData: PropTypes.func,
  fetchLocalities: PropTypes.func,
  resetLocalitiesData: PropTypes.func,
  showActivityLinkCopiedSnackbar: PropTypes.func,
  showDisplayCriteriaModal: PropTypes.func,
  hideDisplayCriteriaModal: PropTypes.func,
  hideActivityCommentModal: PropTypes.func,

  showActivityAnswersModal: PropTypes.func,
  hideActivityAnswersModal: PropTypes.func,
  fetchActivityAnswers: PropTypes.func,
  hideActivityRatingsModal: PropTypes.func,
  fetchActivityRatings: PropTypes.func,
};

ActivityLists.contextTypes = {
  intl:PropTypes.object.isRequired
}

function mapStateToProps(state) {
  const { user, activities, localities } = state.admin;
  return {
    app: state.app,
    isLoading: state.isLoading,
    user,
    activities,
    localities,
  };
}

const mapDispatchToProps = (dispatch) => {
  return {
    doLoginGuest: (data) => dispatch(doLoginGuest(data)),

    fetchHelp: (id) => dispatch(fetchHelp(id)),
    showActivityLinkCopiedSnackbar: (id) => dispatch(showActivityLinkCopiedSnackbar(id)),
    hideActivityModal: () => dispatch(hideActivityModal()),
    hideActivityCommentModal: () => dispatch(hideActivityCommentModal()),
    showDisplayCriteriaModal: (id) => dispatch(showDisplayCriteriaModal(id)),
    hideDisplayCriteriaModal: (id) => dispatch(hideDisplayCriteriaModal(id)),
    resetActivitiesData: (fields) => dispatch(resetActivitiesData(fields)),
    fetchCacheActivities: (id, search, page, perPage, isLoadingDisabled, inDetail, filters) => dispatch(fetchCacheActivities(id, search, page, perPage, isLoadingDisabled, inDetail, filters)),
    fetchOpenActivities: (id, search, page, perPage, isLoadingDisabled, inDetail, filters) => dispatch(fetchOpenActivities(id, search, page, perPage, isLoadingDisabled, inDetail, filters)),
    fetchActivities: (id, search, page, perPage, isLoadingDisabled, inDetail, filters) => dispatch(fetchActivities(id, search, page, perPage, isLoadingDisabled, inDetail, filters)),
    fetchActivity: (id, inDetail) => dispatch(fetchActivity(id, inDetail)),
    deleteActivity: (id, aType) => dispatch(deleteActivity(id, aType)),
    declareCampaignWinners: (id, data) => dispatch(declareCampaignWinners(id, data)),
    updateActivityData: (field, value) => dispatch(updateActivityData(field, value)),
    toggleActivityState: (id, newState, aType) => dispatch(toggleActivityState(id, newState, aType)),
    resetActivitiesError: () => dispatch(resetActivitiesError()),
    cacheListData: (scrollPosition, type, data) => dispatch(cacheListData(scrollPosition, type, data)),
    resetCacheListData: () => dispatch(resetCacheListData()),

    fetchLocalities: (search) => dispatch(fetchLocalities(search)),
    resetLocalitiesData: () => dispatch(resetLocalitiesData),

    showActivityAnswersModal: (id) => dispatch(showActivityAnswersModal(id)),
    hideActivityAnswersModal: () => dispatch(hideActivityAnswersModal()),
    fetchActivityAnswers: (id) => dispatch(fetchActivityAnswers(id)),
    hideActivityRatingsModal: () => dispatch(hideActivityRatingsModal()),
    fetchActivityRatings: (id) => dispatch(fetchActivityRatings(id)),
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withMultipleStyles(baseStyles, useStyles)(withMediaQueries([
    ['isDrawerHidden', theme => theme.breakpoints.down('sm'), {defaultMatches: true}],
    ['isXS', theme => theme.breakpoints.down('xs'), {defaultMatches: true}],
    ['isMD', theme => theme.breakpoints.down('md'), {defaultMatches: true}],
    ['isListC2Up', theme => theme.breakpoints.up('listC2')],
    ['isListC1Down', theme => theme.breakpoints.down('listC1')],
  ])(ActivityLists))
);
